import aguero from "../assets/media/img/staff/Aguero.png"
import alet from "../assets/media/img/staff/Alet.jpg"
import dadic from "../assets/media/img/staff/Dadic.png"
import devicentiis from "../assets/media/img/staff/DeVicentiis.png"
import lauretta from "../assets/media/img/staff/Lauretta.jpg"
import montessi from "../assets/media/img/staff/Montessi.png"
import nicolau from "../assets/media/img/staff/Nicolau.JPG"
import pastor from "../assets/media/img/staff/Pastor.png"
import pingitore from "../assets/media/img/staff/Pingitore.png"
import zareba from "../assets/media/img/staff/Zareba.jpg"
import iermoli from "../assets/media/img/staff/Iermoli.jpg"
import enei from "../assets/media/img/staff/Enei.jpg"
import lallo from "../assets/media/img/staff/Lallo.JPG"
import farinelli from "../assets/media/img/staff/Farinelli.png"
import maffia from "../assets/media/img/staff/maffia.JPG"
import acosta from "../assets/media/img/staff/Acosta.jpeg"
import carchini from "../assets/media/img/staff/carchini.jpg"
import diaz from "../assets/media/img/staff/diaz.jpeg"
import manfredi from "../assets/media/img/staff/Manfredi.png"
import slipak from "../assets/media/img/staff/Slipak.png"
import giarratana from "../assets/media/img/staff/giarratana.jpg"

import adicciones from "../assets/media/img/cursos/addicciones.webp"
import nutriClinica from "../assets/media/img/cursos/posgrado-nutricion.jpg"
import ia from "../assets/media/img/cursos/inteligencia-artificial.png"
import bioFacial from "../assets/media/img/cursos/remodelacion-facial.jpg"
import nutriMicrobiota from "../assets/media/img/cursos/nutricion-microbiota.jpg"
import toxicologia from "../assets/media/img/cursos/toxicologia.jpg"
import nutriDeportiva from "../assets/media/img/cursos/nutricion-deportiva.jpg"
import plantbased from "../assets/media/img/cursos/plantbased.jpg"
import skincare from "../assets/media/img/cursos/skincare.png"
import rcp from "../assets/media/img/cursos/rcp.jpg"
import prehospitalario from "../assets/media/img/cursos/prehospitalario-emergencias.jpg"
import diabetes from "../assets/media/img/cursos/nutricion-y-diabetes.png"
import inmunizaciones from "../assets/media/img/cursos/programa-inmunizaciones.jpg"
import neurocardio from "../assets/media/img/cursos/urgencias-neurocardiologicas.png"
import dermatologia from "../assets/media/img/cursos/dermatologia-estetica-terapeutica.jpg"
import acompAdicciones from "../assets/media/img/cursos/acomp-addiciones.jpg"
import bigData from "../assets/media/img/cursos/big-data.jpg"
import capilar from "../assets/media/img/cursos/transplante-capilar.jpg"
import forense from "../assets/media/img/cursos/forenses.jpg"
import ginecologia from "../assets/media/img/cursos/gineco.webp"
import marketing from "../assets/media/img/cursos/marketing.png"
import oncologica from "../assets/media/img/cursos/enfermeria-oncologica.jpg"
import consumos from "../assets/media/img/cursos/consumos-problematicos.png"
import gestionEnfermeria from "../assets/media/img/cursos/gestion-administracion-enfermeria.jpg"
import medicinaLaboral from "../assets/media/img/cursos/medicina-laboral.jpeg"
import investigacionClinica from "../assets/media/img/cursos/investigacion-clinica.jpg"
import psiquiatria from "../assets/media/img/cursos/psiquiatria-clinica.png"
import gestionDigital from "../assets/media/img/cursos/gestion-digital.jpg"
import neurologica from "../assets/media/img/cursos/enfermeria-neurologica.png"
import telemedicina from "../assets/media/img/cursos/telemedicina.jpg"
import VideoTelemedicina from "../assets/media/vid/cursos/VideoTelemedicina.mp4"

const cursos = [
    {
        id: 206,
        codigoT: "400.21",
        nombre: "Posgrado en Psiquiatría Clínica",
        foto: psiquiatria,
        url: "posgrado-psiquiatria-clinica",
        tipo: "Posgrado",
        categoria: ["psiquiatria"],
        area: "Psiquiatría Clínica",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Médicos, según los requisitos del programa." }
        ],
        descripcion: "El desarrollo del Posgrado tiene como objetivo cubrir una brecha importante en la formación profesional, brindando herramientas específicas para abordar de manera efectiva las crisis psiquiátricas que se presentan tanto en el ámbito hospitalario como en la comunidad.",
        descripcionExtra: [],
        descripcionPreview: "Formación clínica para abordar urgencias y problemáticas psiquiátricas en ámbitos hospitalarios y comunitarios.",
        sobreTitulo: "Abordaje integral de las urgencias y problemáticas psiquiátricas",
        objetivos: [
            "Evaluar y abordar urgencias psiquiátricas en ámbitos hospitalarios y comunitarios.",
            "Reconocer y tratar cuadros agudos vinculados con psicosis, trastornos del ánimo, ansiedad y riesgo suicida.",
            "Aplicar intervenciones farmacológicas, psicológicas y de crisis basadas en criterios clínicos actuales.",
            "Integrar los aspectos legales, éticos y comunicacionales del manejo psiquiátrico."
        ],
        sistemaEvaluacion: [
            "Dos exámenes parciales",
            "Actividad en foro",
            "Análisis y resolución de casos clínicos",
            "Examen final"
        ],
        destinatarioTags: [
            "Médicos psiquiatras",
            "Médicos que intervienen en salud mental"
        ],
        director: ["Dr. Oscar Slipak"],
        directorDetalle: ["Director del Posgrado"],
        direccionAcademica: [
            { nombre: "Dr. Oscar Slipak", detalle: "Director del Posgrado" }
        ],
        equipoDocente: [
            { titulo: "Dra.", nombre: "Agustina Maneiro" },
            { titulo: "Dr.", nombre: "Francisco Dadic" },
            { titulo: "Dra.", nombre: "Vanina Ciaramiraro" }
        ],
        genero: "",
        directorImg: [slipak],
        inicio: "29/03/2027",
        fin: null,
        diasHorarios: "Lunes 20 a 22 hs",
        quincenal: false,
        clases: 34,
        horas: 370,
        duracion: 10,
        destinatarios: "Médicos/as psiquiatras y médicos/as que se desempeñen en áreas que requieran intervención en salud mental.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a la carrera de medicina",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de medicina y convalidado por la Institución competente nacional Argentina"
        ],
        modalidad: "Virtual",
        temario: 21,
        video: null,
        precioArg: 3525000,
        precioArgDescuento: 2467500,
        precioCuotasArg: 293750,
        precioCuotasArgDescuento: 235000,
        precioExt: 2311.48,
        precioExtDescuento: 1618.03,
        precioCuotasExt: 192.62,
        precioCuotasExtDescuento: 154.10,
        cuotas: 12,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/1aCteNy",
        linkpagoExt: "https://www.paypal.com/ncp/payment/7JUQMLB9SB334",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-3AT30057J45754533NLJD6TY",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 205,
        codigoT: "400.20",
        nombre: "Posgrado en Gestión y Administración en Enfermería",
        foto: gestionEnfermeria,
        url: "posgrado-gestion-administracion-enfermeria",
        tipo: "Posgrado",
        categoria: ["enfermeria"],
        area: "Enfermería",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La gestión y administración efectiva de los servicios de enfermería se ha convertido en un factor clave para asegurar la calidad y eficiencia de la atención sanitaria. La evidencia científica respalda la importancia de contar con profesionales de enfermería con habilidades en gestión, liderazgo y toma de decisiones informadas para enfrentar los retos actuales y futuros en el ámbito de la salud.",
        descripcionExtra: [],
        descripcionPreview: "Formación en gestión, liderazgo y toma de decisiones para mejorar la calidad y eficiencia de los servicios de enfermería.",
        sobreTitulo: "",
        objetivos: [
            "Formar profesionales de enfermería altamente capacitados en la gestión y administración de servicios de salud, mediante el desarrollo de competencias en liderazgo y planificación estratégica.",
            "Desarrollar competencias en gestión de recursos, investigación, innovación y uso de herramientas tecnológicas.",
            "Promover la toma de decisiones basadas en la evidencia científica y la mejora continua.",
            "Optimizar los procesos de gestión y garantizar una atención integral, segura, eficiente y de calidad, centrada en el paciente."
        ],
        sistemaEvaluacion: [
            "Dos exámenes parciales",
            "Actividad en foro",
            "Entrega de trabajos prácticos",
            "Examen final"
        ],
        destinatarioTags: ["Licenciados en Enfermería"],
        director: ["Lic. Esp. Leonardo De Vincentiis"],
        directorDetalle: ["(MN 72146) · Licenciado en Enfermería"],
        direccionAcademica: [
            { nombre: "Lic. Esp. Leonardo De Vincentiis", detalle: "(MN 72146) · Licenciado en Enfermería" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Mag.", nombre: "Ana María Mosca" },
            { titulo: "Mag.", nombre: "Cinthia De Armas" },
            { titulo: "Mag.", nombre: "Matías Isólica" },
            { titulo: "Mag.", nombre: "Nicolás Matiz" },
            { titulo: "Mag.", nombre: "Raúl Ureta" },
            { titulo: "Lic. Esp.", nombre: "Andrea Leyton" },
            { titulo: "Lic. Esp.", nombre: "Romina D´Arano" },
            { titulo: "Lic.", nombre: "Jaqueline Perez Pizarro" },
            { titulo: "Lic.", nombre: "Emma Abalos" },
            { titulo: "Lic. Esp.", nombre: "María José Aybar" },
        ],
        directorImg: [devicentiis],
        inicio: "09/04/2027",
        fin: null,
        diasHorarios: "Viernes 20 a 22 hs",
        quincenal: false,
        clases: 34,
        horas: 370,
        duracion: 10,
        unidades: null,
        destinatarios: "Dirigido a Licenciados en Enfermería y Enfermeros profesionales.",
        requisitos: [
            "Graduado con título de grado correspondiente a la Licenciatura en Enfermería"
        ],
        modalidad: "Virtual",
        temario: 20,
        precioArg: 2025000,
        precioArgDescuento: 1417500,
        precioCuotasArg: 168750,
        precioCuotasArgDescuento: 135000,
        precioExt: 1327.87,
        precioExtDescuento: 929.51,
        precioCuotasExt: 110.66,
        precioCuotasExtDescuento: 88.53,
        cuotas: 12,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/1FJgyLp",
        linkpagoExt: "https://www.paypal.com/ncp/payment/76647CP79FNCE",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-32V682274K4236235NLJFUHQ",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 204,
        codigoT: "400.19",
        nombre: "Posgrado en Dermatología Estética y Terapéutica",
        foto: dermatologia,
        url: "posgrado-dermatologia-estetica-terapeutica",
        tipo: "Posgrado",
        categoria: ["dermatologia"],
        area: "Estética",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Este posgrado de dermatología estética y terapéutica permitirá que al finalizar el mismo, cada médico tenga las herramientas teóricas y la práctica para desenvolverse en esta actividad y así obtener los más altos rendimientos en cada tratamiento que realice.",
        descripcionExtra: [],
        descripcionPreview: "Herramientas teóricas y prácticas para desenvolverse en dermatología estética y terapéutica. Doble titulación FISP + UBA.",
        sobreTitulo: "Formación integral en dermatología estética y terapéutica",
        objetivos: ["Capacitar a los cursantes a realizar un correcto diagnóstico. Adquirir conocimientos necesarios y actualizados para el tratamiento de la patología diagnosticada, junto a la práctica necesaria para realizar procedimientos.", "Concientizar al cursante que cada paciente es único, y que el tratamiento a realizar debe ser personalizado.", "Aportar los conceptos legales necesarios para adentrarse en el campo de la dermatología estética y terapéutica."],
        sistemaEvaluacion: ["Dos exámenes parciales", "Actividad en foro", "Trabajos prácticos", "Prácticas finales", "Examen final"],
        destinatarioTags: ["Médicos", "Odontólogos", "Graduados de universidades argentinas", "Graduados de universidades extranjeras"],
        director: ["Dra. Sylvia B. Pingitore"],
        directorDetalle: ["Directora del Posgrado · (MN 50620) · Dermatóloga · Fundación Iberoamericana de Salud Pública"],
        direccionAcademica: [
            { nombre: "Dra. Sylvia B. Pingitore", detalle: "Directora del Posgrado · (MN 50620) · Dermatóloga · Fundación Iberoamericana de Salud Pública" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Diego Slipak (Co-Director)" },
            { titulo: "Dr.", nombre: "Eduardo Pittaro" },
            { titulo: "Dra.", nombre: "Aldana Lallo" },
            { titulo: "Dra.", nombre: "Agustina Maneiro" },
            { titulo: "Dr.", nombre: "Alfredo Ruiz Díaz" }
        ],
        directorImg: [pingitore],
        inicio: "31/03/2027",
        fin: null,
        "practica final": null,
        diasHorarios: "Miércoles 18 a 20 hs",
        quincenal: false,
        clases: 38,
        horas: 370,
        duracion: 10,
        unidades: 9,
        destinatarios: "Dirigido a médicos/as y odontólogos/as. Obtendrán titulación FISP + Facultad de Medicina UBA.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a las carreras de Medicina u Odontología.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a las carreras de Medicina u Odontología."
        ],
        modalidad: "Clases virtuales + Prácticas finales",
        temario: 19,
        precioArg: 4200000,
        precioArgDescuento: 2940000,
        precioCuotasArg: 350000,
        precioCuotasArgDescuento: 280000,
        precioExt: 2754.10,
        precioExtDescuento: 1927.87,
        precioCuotasExt: 229.51,
        precioCuotasExtDescuento: 183.61,
        cuotas: 12,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/2edMisu",
        linkpagoExt: "https://www.paypal.com/ncp/payment/D8A9YA9APDWYS",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-6P957568B2507621MNLJFVZY",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 215,
        codigoT: "400.24",
        nombre: "Posgrado en Nutrición Clínica",
        foto: nutriClinica,
        url: "posgrado-nutricion-clinica",
        tipo: "Posgrado",
        categoria: ["nutricion"],
        area: "Nutrición",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La nutrición tiene un papel fundamental en el estado de salud de las personas. Es necesario que los profesionales alcancen un dominio elevado en esta área, manteniendo de forma permanente una puesta al día, que permita evaluar un tratamiento terapéutico adecuado para cada individuo.",
        descripcionExtra: ["Contamos con un programa completo mediante el cual, cada profesional, recibirá todo el conocimiento actualizado y necesario sobre la nutrición clínica, pudiendo abordar cada paciente de una forma integral y personalizada."],
        descripcionPreview: "Formación integral y actualizada en nutrición clínica para el abordaje personalizado. Doble titulación FISP + UBA.",
        sobreTitulo: "La nutrición como pilar fundamental del estado de salud",
        objetivos: ["Brindar al profesional los conocimientos científicos actualizados sobre la nutrición.", "Establecer un programa de tratamiento que incluya a todo el equipo de salud abordando cambios en el estilo de vida, educación terapéutica, estrategias de adherencia, acompañamiento terapéutico y familiar.", "Aportar a los profesionales herramientas nuevas para favorecer la adherencia sobre los cambios necesarios en el estilo de vida del paciente."],
        sistemaEvaluacion: ["Dos exámenes parciales", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Lic. en Nutrición", "Médicos de Familia", "Clínicos", "Generalistas", "Endocrinología", "Psiquiatría", "Cardiología", "Graduados UBA y otras universidades"],
        director: ["Dra. Elena Pastor Manfredi"],
        directorDetalle: ["Directora del Posgrado · (MN 163753) · Especialista en Nutrición · Fundación Iberoamericana de Salud Pública"],
        direccionAcademica: [
            { nombre: "Dra. Elena Pastor Manfredi", detalle: "Directora del Posgrado · (MN 163753) · Especialista en Nutrición · Fundación Iberoamericana de Salud Pública" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Raúl F. Pastor (Co-Director)" },
            { titulo: "Lic.", nombre: "Laura Iermoli" },
            { titulo: "Dra.", nombre: "Isabel Pastor" },
            { titulo: "Dra.", nombre: "M. Eugenia Leone" },
            { titulo: "Dr.", nombre: "Mario Groberman" },
            { titulo: "Dra.", nombre: "M. Florencia Correa" },
            { titulo: "Dra.", nombre: "Gabriela Comesaña" },
            { titulo: "Dr.", nombre: "Anibal Manfredi" }
        ],
        directorImg: [manfredi],
        inicio: "01/04/2027",
        fin: null,
        diasHorarios: "Jueves 18 a 20 hs",
        quincenal: false,
        clases: 38,
        horas: 370,
        duracion: 10,
        unidades: 12,
        destinatarios: "Dirigido a Licenciadas/os en Nutrición y otros profesionales de la salud que requieran conocimiento sobre nutrición para la práctica profesional.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a una profesión relacionada a la salud.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a una profesión relacionada a la salud"
        ],
        modalidad: "Virtual",
        temario: 25,
        precioArg: 3750000,
        precioArgDescuento: 2625000,
        precioCuotasArg: 312500,
        precioCuotasArgDescuento: 250000,
        precioExt: 2459.02,
        precioExtDescuento: 1721.31,
        precioCuotasExt: 204.92,
        precioCuotasExtDescuento: 163.94,
        cuotas: 12,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/1HSeHXw",
        linkpagoExt: "https://www.paypal.com/ncp/payment/TQ3FCK67ARDG6",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-3LY07691PY000343YNLJFYOI",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 236,
        codigoT: "400.34",
        nombre: "Posgrado en Investigación Clínica",
        foto: investigacionClinica,
        url: "posgrado-investigacion-clinica",
        tipo: "Posgrado",
        categoria: ["investigacion-clinica"],
        area: "Investigación Clínica",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Graduados universitarios de Medicina y carreras de salud afines, según los requisitos del programa." }
        ],
        descripcion: "El programa aborda la investigación de farmacología clínica integral, desde la concepción y el diseño del protocolo hasta el cierre y archivo del estudio. Incorpora la perspectiva del equipo investigador, la calidad del dato asistencial, la preparación de auditorías e inspecciones y el trabajo con los actores internos y externos del ensayo.",
        descripcionExtra: [
            "El ecosistema de la investigación clínica atraviesa una transformación impulsada por la inteligencia artificial, los macrodatos de salud y la bioinformática. El posgrado incorpora brazos de control sintéticos, Real-World Evidence, ensayos clínicos descentralizados, IA generativa aplicada al dossier y al monitoreo, y nuevos diseños metodológicos adaptativos.",
            "Dirigido por el Dr. Manfredo Cozzi, se enmarca en la cooperación entre FISP y la Facultad de Medicina de la Universidad de Buenos Aires, con doble certificación al finalizar la cursada."
        ],
        descripcionPreview: "Formación avanzada en investigación clínica: diseño de protocolos, Buenas Prácticas Clínicas, regulación, bioestadística, monitoreo, auditorías e innovación tecnológica.",
        sobreTitulo: "Formación académica avanzada en Investigación Clínica",
        objetivos: [
            "Comprender los fundamentos históricos y éticos de la investigación con seres humanos.",
            "Aplicar principios de Buena Práctica Clínica (GCP ICH E6(R3)) con un enfoque de calidad basado en riesgo.",
            "Interpretar el marco regulatorio argentino y evaluar protocolos y planes estadísticos básicos.",
            "Gestionar la operación de un centro de investigación y comprender la gestión de datos y la seguridad.",
            "Evaluar críticamente el uso de inteligencia artificial y nuevas tecnologías en investigación clínica.",
            "Interactuar eficazmente con los actores relevantes para el equipo del investigador."
        ],
        sistemaEvaluacion: [
            "Evaluaciones de opción múltiple por módulo",
            "Actividades prácticas individuales y grupales, y análisis de casos",
            "Participación en foros, talleres y clases interactivas",
            "Trabajo Final Integrador: análisis de protocolo, complementación de CTMS, tratamiento en CEI y análisis de riesgos para monitoreo y auditoría. Se presenta por Campus dentro de los 90 días corridos desde su recepción."
        ],
        destinatarioTags: [
            "Medicina",
            "Enfermería",
            "Farmacia",
            "Bioquímica",
            "Kinesiología",
            "Nutrición",
            "Odontología",
            "Psicología"
        ],
        director: ["Dr. Manfredo Cozzi"],
        directorDetalle: ["Director del Posgrado"],
        direccionAcademica: [
            { nombre: "Dr. Manfredo Cozzi", detalle: "Director del Posgrado" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dra.", nombre: "Carolina Sian", detalle: "Directora de Asuntos Regulatorios en CAEMe" },
            { titulo: "Dra.", nombre: "Laura Traversi", detalle: "Jefa del Departamento de Evaluación de Ensayos Clínicos de ANMAT" },
            { titulo: "Dra.", nombre: "Fanny Kataife", detalle: "Jefa del Servicio de Inspecciones del Departamento de Evaluación de Ensayos Clínicos de ANMAT" },
            { titulo: "Dra.", nombre: "Inés Sanmartino", detalle: "Jefa del Servicio de Seguridad y Eficacia del Departamento de Evaluación de Ensayos Clínicos de ANMAT" },
            { titulo: "Dr.", nombre: "Carlos Burguer", detalle: "Coordinador del Comité de Ética Central del Ministerio de Salud de la Provincia de Buenos Aires" },
            { titulo: "Dr.", nombre: "Pablo Viard", detalle: "Director Regional de Ensayos Clínicos en Bristol Myers Squibb" },
            { titulo: "Dra.", nombre: "Cecilia D’Antuono", detalle: "Directora Asociada de Ensayos Clínicos en Bristol Myers Squibb" },
            { titulo: "Dra.", nombre: "Fabiana Ibelli", detalle: "Presidenta del Comité de Bioética de FEFyM" },
            { titulo: "Lic.", nombre: "Leonardo Perelis", detalle: "Coordinador del Comité de Bioética del Hospital Ramos Mejía" },
            { titulo: "Lic.", nombre: "Noelia Buet", detalle: "Gerenta de Asuntos Regulatorios de Johnson & Johnson" },
            { titulo: "Dra.", nombre: "Karina de Lazzari", detalle: "Head of Latam Delivery de Syneos Health" }
        ],
        directorImg: [],
        inicio: "11/03/2027",
        fin: null,
        diasHorarios: "Jueves 18 a 20 hs",
        quincenal: false,
        clases: 38,
        horas: 370,
        duracion: 10,
        unidades: 10,
        destinatarios: "Dirigido a graduados universitarios de Medicina y carreras de salud afines interesados en especializarse en investigación de farmacología clínica. Se requiere título universitario de grado en ciencias de la salud o áreas afines, currículum vitae actualizado, completar los formularios de inscripción y, cuando el comité académico lo considere necesario, una entrevista de admisión.",
        requisitos: [
            "Título universitario de grado en ciencias de la salud o áreas afines.",
            "Currículum vitae actualizado.",
            "Completar los formularios de inscripción.",
            "Entrevista de admisión cuando el comité académico lo considere necesario.",
            "Manejo del idioma inglés para la lectura de textos técnicos."
        ],
        modalidad: "Virtual sincrónico y asincrónico",
        temario: 34,
        precioArg: 3500000,
        precioArgDescuento: 2450000,
        precioCuotasArg: 291666.67,
        precioCuotasArgDescuento: 233333,
        precioExt: 2295.08,
        precioExtDescuento: 1606.56,
        precioCuotasExt: 191.26,
        precioCuotasExtDescuento: 153.01,
        cuotas: 12,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/1zYxSW6",
        linkpagoExt: "https://www.paypal.com/ncp/payment/7P8THY3XJY95A",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-9WC399031J8005511NLJFZNA",
        inscripcionAnio: 2027,
        pageContent: {
            dataCardTitle: "Datos del posgrado",
            heroFacts: [
                ["🎓", "Certificación", "FISP + UBA"],
                ["Ⅱ", "Modalidad", "Virtual sincrónica y asincrónica"],
                ["📚", "Unidades", "10 unidades"],
                ["⏱️", "Horario", "Jueves 18 a 20 hs"],
                ["💻", "Online", "100% online"]
            ],
            infoBarItems: [
                "🩺 Dirigido por el Dr. Manfredo Cozzi",
                "🎓 Doble titulación FISP + Facultad de Medicina UBA",
                "💻 A distancia · Jueves 18 hs · 370 hs cátedra"
            ],
            aboutTag: "Sobre el posgrado",
            aboutTitle: "Formación académica avanzada en Investigación Clínica",
            objectivesTag: "Objetivos del programa",
            audienceTag: "¿A quién está dirigido?",
            temarioHeading: "10 módulos · Marzo a diciembre de 2027",
            methodCards: [
                {
                    icon: "📹",
                    title: "Clases en vivo y asincrónicas",
                    text: "Encuentros en vivo los jueves a las 18 hs, más clases grabadas, bibliografía, materiales y autoevaluación en el Campus."
                },
                {
                    icon: "💬",
                    title: "Instancias interactivas",
                    text: "Foros moderados, talleres y clínicas de consulta para resolver dudas y analizar casos."
                },
                {
                    icon: "📖",
                    title: "370 horas cátedra",
                    text: "Marzo a diciembre de 2027, con Trabajo Final Integrador al finalizar la cursada."
                }
            ],
            showAudienceTags: true,
            sidebarFactsTitle: "Ficha del programa",
            sidebarFacts: [
                ["Programa", "Posgrado"],
                ["Área", "Investigación Clínica"],
                ["Duración", "10 meses"],
                ["Unidades", "10 unidades"],
                ["Modalidad", "Virtual sincrónica y asincrónica"],
                ["Inicio", "11/03/2027"],
                ["Horario", "Jueves 18 a 20 hs"],
                ["Frecuencia", "Clases semanales"],
                ["Carga horaria", "370 hs cátedra"]
            ],
            sidebarNote: "Vacantes limitadas. Consultar formas de pago.",
            certificationTitle: "Doble titulación",
            certificationDescription: "Certificado de Posgrado emitido por la Fundación Iberoamericana de Salud Pública y la Facultad de Medicina de la Universidad de Buenos Aires."
        },
        cuposLlenos: false,
    },
    {
        id: 214,
        codigoT: "400.25",
        nombre: "Posgrado en Nutrición y Microbiota",
        foto: nutriMicrobiota,
        url: "posgrado-nutricion-microbiota",
        tipo: "Posgrado",
        categoria: ["nutricion"],
        area: "Nutrición",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "El Posgrado en Nutrición y Microbiota ofrece una formación avanzada sobre la relación entre alimentación, salud y el equilibrio del ecosistema intestinal.",
        descripcionExtra: ["Con base en la evidencia científica más actual, capacita a profesionales para intervenir de forma integral y personalizada en el tratamiento de diversas patologías, promoviendo el desarrollo de una microbiota saludable y el control de microorganismos patógenos. Un enfoque actualizado y clínicamente relevante, clave en la práctica nutricional moderna."],
        descripcionPreview: "Formación especializada en el vínculo entre nutrición y microbiota, con enfoque integral y actualizado para el abordaje clínico personalizado.",
        sobreTitulo: "La microbiota como pilar fundamental del estado de salud",
        objetivos: ["Brindar al profesional los conocimientos científicos actualizados sobre la Microbiota.", "Establecer un programa de tratamiento que incluya a todo el equipo de salud abordando cambios en el estilo de vida, educación terapéutica, estrategias de adherencia, acompañamiento terapéutico (farmacológico y no farmacológico) y familiar.", "Aportar a los profesionales nuevas herramientas para favorecer la adherencia sobre los cambios necesarios en el estilo de vida de cada paciente para lograr un óptimo objetivo."],
        sistemaEvaluacion: ["Dos exámenes parciales", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Médicos", "Licenciados/as en Nutrición"],
        director: ["Dra. Elena Pastor Manfredi"],
        directorDetalle: ["Directora del Posgrado · (MN 163753) · Especialista en Nutrición · Fundación Iberoamericana de Salud Pública"],
        direccionAcademica: [
            { nombre: "Dra. Elena Pastor Manfredi", detalle: "Directora del Posgrado · (MN 163753) · Especialista en Nutrición · Fundación Iberoamericana de Salud Pública" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Raúl F. Pastor (Co-Director)" },
            { titulo: "Dr.", nombre: "Roberto H. Iermoli" },
            { titulo: "Lic.", nombre: "Laura Iermoli" },
            { titulo: "Dra.", nombre: "Maria Piekar" },
            { titulo: "Dra.", nombre: "Luciana Vasconsellos" },
            { titulo: "Dra.", nombre: "Victoria Cólica" }
        ],
        genero: "a",
        directorImg: [manfredi],
        inicio: "09/04/2027",
        fin: null,
        diasHorarios: "Viernes 18 a 20 hs",
        quincenal: false,
        clases: 36,
        horas: 370,
        duracion: 10,
        unidades: 22,
        destinatarios: "Dirigido a Licenciadas/os en Nutrición y otros profesionales de la salud que requieran conocimiento sobre nutrición para la práctica profesional.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a una profesión relacionada a la salud.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a una profesión relacionada a la salud."
        ],
        modalidad: "Virtual",
        temario: 24,
        video: null,
        precioArg: 3750000,
        precioArgDescuento: 2625000,
        precioCuotasArg: 312500,
        precioCuotasArgDescuento: 250000,
        precioExt: 2459.02,
        precioExtDescuento: 1721.31,
        precioCuotasExt: 204.92,
        precioCuotasExtDescuento: 163.94,
        cuotas: 12,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/32Xjk3D",
        linkpagoExt: "https://www.paypal.com/ncp/payment/ASL8QQLWQG8X2",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-03U08915DM0478326NLJF26A",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 234,
        codigoT: "400.26",
        nombre: "Posgrado en Big Data e IA en Salud",
        foto: bigData,
        url: "posgrado-bigdata-ia-salud",
        tipo: "Posgrado",
        categoria: ["tecnologia", "medicina-de-precision"],
        area: "Big Data e IA",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Profesionales de la salud y estudiantes del último año vinculados al área salud, según los destinatarios del programa." },
            { certificacion: "FISP", aplicaA: "Profesionales de otras carreras, estudiantes u otros perfiles indicados en los destinatarios del programa." }
        ],
        descripcion: "Actualmente, las ciencias médicas se enfrentan a grandes y crecientes retos. La Inteligencia Artificial representa no solo un avance tecnológico prometedor, sino una posible respuesta a múltiples problemáticas. La Organización Mundial de la Salud reconoce el valor de la IA y juega un papel activo en convertirla en una herramienta integrada de los sistemas de salud.",
        descripcionExtra: ["La ciencia de datos es fundamental para el desarrollo y aplicación de la IA, ya que proporciona las herramientas y metodologías necesarias para transformar grandes volúmenes de información en conocimiento útil. El increíble potencial de esta tecnología nos obliga a su desarrollo constante, brindando educación de calidad a profesionales de la salud."],
        descripcionPreview: "Ciencia de datos e Inteligencia Artificial aplicadas a la salud, desde sus fundamentos hasta su implementación clínica.",
        sobreTitulo: "Ciencia de datos e Inteligencia Artificial al servicio de la salud",
        objetivos: ["Brindar al profesional los conocimientos fundamentales y sólidos acerca de la ciencia de datos orientada a salud e Inteligencia Artificial (IA), desde sus fundamentos básicos hasta el alcance de su aplicación en salud."],
        sistemaEvaluacion: ["Dos exámenes parciales", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Médicos", "Profesionales de la salud", "Profesionales de otras carreras con título de grado", "Graduados universidades argentinas", "Graduados universidades extranjeras"],
        director: ["Dr. Paolo Lauretta"],
        directorDetalle: ["Director de Salud Digital de FISP · Artificial Intelligence in Health Care (MIT)"],
        direccionAcademica: [
            { nombre: "Dr. Paolo Lauretta", detalle: "Director de Salud Digital de FISP · Artificial Intelligence in Health Care (MIT)" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Lic.", nombre: "Jesica Formoso (Co-Directora)", detalle: "Investigadora Conicet - Data Science - R - Python", },
            { titulo: "Lic.", nombre: "Karina Formoso (Co-Directora)", detalle: "Investigadora Conicet - Biotecnóloga", },
            { titulo: "Ing.", nombre: "Alberto Ortega", detalle: "Digital Native Account Manager @ AWS" }
        ],
        directorImg: [lauretta],
        inicio: "30/03/2027",
        fin: null,
        diasHorarios: "Martes 18 a 20 hs",
        quincenal: false,
        clases: 38,
        horas: 370,
        duracion: 10,
        unidades: 7,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a una profesión relacionada a la salud.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a una profesión relacionada a la salud.",
            "c) Ser graduado de universidades argentinas con título de otras carreras profesionales.",
            "d) Ser graduado de universidades extranjeras con título de otras carreras profesionales.",
        ],
        modalidad: "Virtual",
        temario: 26,
        precioArg: 4900000,
        precioArgDescuento: 3430000,
        precioCuotasArg: 408333.33,
        precioCuotasArgDescuento: 326667,
        precioExt: 3213.11,
        precioExtDescuento: 2249.18,
        precioCuotasExt: 267.76,
        precioCuotasExtDescuento: 214.21,
        cuotas: 12,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/2vTbg9s",
        linkpagoExt: "https://www.paypal.com/ncp/payment/WUTFK3M8SMURS",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-7CU55095YM7814045NLJF34Q",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 235,
        codigoT: "400.27",
        nombre: "Posgrado en Gestión Digital de Establecimientos y Sistemas de Salud",
        foto: gestionDigital,
        url: "posgrado-gestion-de-establecimientos-sistemas-de-salud-digital",
        tipo: "Posgrado",
        categoria: ["tecnologia"],
        area: "Tecnología",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Este posgrado busca capacitar profesionales en la gestión estratégica de sistemas y establecimientos de salud digital, integrando conocimientos sobre salud digital, interoperabilidad, telemedicina, analítica de datos, inteligencia artificial y políticas sanitarias",
        descripcionExtra: [],
        descripcionPreview: "Gestión estratégica de sistemas y establecimientos de salud digital, integrando tecnología, procesos y atención sanitaria.",
        sobreTitulo: "Transformación digital aplicada a la gestión de sistemas de salud",
        objetivos: [
            "Comprender los fundamentos de la salud digital y su impacto en los sistemas sanitarios.",
            "Planificar e implementar sistemas de información, historias clínicas electrónicas y soluciones interoperables.",
            "Integrar analítica de datos, inteligencia artificial, telemedicina y ciberseguridad en la gestión institucional.",
            "Liderar proyectos de transformación digital centrados en las personas y evaluar sus resultados."
        ],
        sistemaEvaluacion: [
            "Evaluaciones parciales",
            "Actividades prácticas y análisis de casos",
            "Proyecto final integrador",
            "Presentación final del proyecto"
        ],
        destinatarioTags: [
            "Médicos",
            "Profesionales de la salud",
            "Gestores de instituciones de salud",
            "Profesionales de otras carreras con título de grado"
        ],
        director: ["Dr. Paolo Lauretta"],
        directorDetalle: ["Director del Posgrado"],
        direccionAcademica: [
            { nombre: "Dr. Paolo Lauretta", detalle: "Director del Posgrado" }
        ],
        equipoDocente: [
            { titulo: "Dr.", nombre: "German Nestasio" },
            { titulo: "Dr.", nombre: "Gustavo Giarratana" },
            { titulo: "", nombre: "Franco Imbrognio" },
            { titulo: "", nombre: "Karina Formoso" },
            { titulo: "", nombre: "Jesica Formoso" }
        ],
        genero: "",
        directorImg: [lauretta],
        inicio: "31/03/2027",
        fin: null,
        diasHorarios: "Miércoles 20 a 22 hs",
        quincenal: false,
        clases: 38,
        horas: 370,
        duracion: 10,
        destinatarios: "Dirigido a Médicos y profesionales de la salud y a profesionales de otras carreras con título de grado. Titulación: FISP + UBA.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a una profesión relacionada a la salud.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a una profesión relacionada a la salud.",
            "c) Ser graduado de universidades argentinas con título de otras carreras profesionales.",
            "d) Ser graduado de universidades extranjeras con título de otras carreras profesionales.",
        ],
        modalidad: "Virtual",
        temario: 27,
        video: null,
        precioArg: 3300000,
        precioArgDescuento: 2310000,
        precioCuotasArg: 275000,
        precioCuotasArgDescuento: 220000,
        precioExt: 2163.93,
        precioExtDescuento: 1514.75,
        precioCuotasExt: 180.33,
        precioCuotasExtDescuento: 144.26,
        cuotas: 12,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/1Yxfwq4",
        linkpagoExt: "https://www.paypal.com/ncp/payment/4AHFKCRAZNXRL",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-93E42614M7860150VNLJGCVQ",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 122,
        codigoT: "400.9",
        nombre: "Posgrado en Enfermería Oncológica: liderazgo clínico y gestión de servicios",
        foto: oncologica,
        url: "posgrado-enfermeria-oncologica",
        tipo: "Posgrado",
        categoria: ["enfermeria"],
        area: "Enfermería Oncológica",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Formarte en enfermería oncológica es asumir el compromiso de brindar cuidados especializados en cada etapa del tratamiento. Este posgrado te prepara para intervenir con rigor científico, acompañar a los pacientes con sensibilidad, liderar equipos y gestionar servicios de enfermería oncológica.",
        descripcionExtra: [],
        descripcionPreview: "Formación especializada para el cuidado integral, el liderazgo clínico y la gestión de servicios de enfermería oncológica en adultos y pediatría.",
        sobreTitulo: "Liderazgo clínico y gestión de servicios de enfermería oncológica",
        objetivos: [
            "Profundizar el cuidado integral del paciente oncológico adulto y pediátrico durante las distintas etapas del tratamiento.",
            "Aplicar intervenciones seguras en cirugía, radioterapia, quimioterapia, inmunoterapia y oncohematología.",
            "Gestionar servicios de enfermería oncológica con criterios de calidad, seguridad y atención centrada en la persona.",
            "Fortalecer el liderazgo, la educación al paciente y la familia, la bioética y el autocuidado profesional."
        ],
        sistemaEvaluacion: [
            "Dos exámenes parciales",
            "Actividad en foro",
            "Entrega de trabajos prácticos",
            "Examen final"
        ],
        destinatarioTags: ["Licenciados en Enfermería", "Enfermeros profesionales"],
        director: ["Lic. Esp. Leonardo De Vincentiis"],
        directorDetalle: ["(MN 72146) · Licenciado en Enfermería"],
        direccionAcademica: [
            { nombre: "Lic. Esp. Leonardo De Vincentiis", detalle: "(MN 72146) · Licenciado en Enfermería" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Mag.", nombre: "María Constanza Celano" },
            { titulo: "Lic.", nombre: "Paola Arellano" },
            { titulo: "Lic.", nombre: "Sandra Ibarra" },
            { titulo: "Lic.", nombre: "Silvana Chero" },
        ],
        directorImg: [devicentiis],
        inicio: "01/04/2027",
        fin: null,
        diasHorarios: "Jueves 20 a 22 hs",
        quincenal: false,
        clases: 40,
        horas: 370,
        duracion: 10,
        unidades: 11,
        destinatarios: "Dirigido a Licenciados en Enfermería y Enfermeros profesionales.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a la carrera de Licenciatura en Enfermería.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Licenciatura en Enfermería"
        ],
        modalidad: "Virtual",
        temario: 9,
        precioArg: 1900000,
        precioArgDescuento: 1330000,
        precioCuotasArg: 158333.33,
        precioCuotasArgDescuento: 126667,
        precioExt: 1245.90,
        precioExtDescuento: 872.13,
        precioCuotasExt: 103.83,
        precioCuotasExtDescuento: 83.06,
        cuotas: 12,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/1QHeN5p",
        linkpagoExt: "https://www.paypal.com/ncp/payment/EJ76UQCC3XE3S",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-2C813894359400126NLJGDWY",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 208,
        codigoT: "400.23",
        nombre: "Posgrado en Toxicología",
        foto: toxicologia,
        url: "posgrado-toxicologia",
        tipo: "Posgrado",
        categoria: ["salud-mental-y-adicciones"],
        area: "Toxicología",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La toxicología es una disciplina fundamental en la intersección entre las ciencias médicas, químicas y ambientales. Su conocimiento resulta imprescindible para el abordaje clínico de pacientes expuestos a sustancias tóxicas, la evaluación de riesgos sanitarios, el diseño de políticas públicas y la intervención frente a eventos químicos de interés sanitario o criminalístico.",
        descripcionExtra: ["Este posgrado ofrece una formación integral y actualizada que abarca desde los fundamentos de la toxicología general hasta los aspectos clínicos, ambientales, ocupacionales y sociales del fenómeno tóxico, con especial énfasis en la prevención, diagnóstico, tratamiento y gestión de intoxicaciones agudas y crónicas."],
        descripcionPreview: "Formación integral y actualizada en toxicología médica, ambiental, ocupacional y forense. Doble titulación FISP + UBA.",
        sobreTitulo: "Una disciplina fundamental en la intersección de las ciencias médicas, químicas y ambientales",
        objetivos: ["Brindar conocimientos actualizados en toxicología médica, ambiental, ocupacional y forense.", "Capacitar en el abordaje integral del paciente expuesto a tóxicos, desde la evaluación inicial hasta el tratamiento y seguimiento.", "Profundizar en el análisis de sustancias de abuso, drogas sintéticas, precursores químicos y estrategias de prevención.", "Desarrollar habilidades para la evaluación toxicológica en contextos clínicos, periciales y de políticas públicas.", "Promover el análisis crítico de la evidencia científica y el trabajo interdisciplinario en toxicología."],
        sistemaEvaluacion: ["Dos exámenes parciales", "Actividades en foro", "Entrega de trabajos prácticos", "Trabajo integrador", "Participación en clases sincrónicas", "Examen final"],
        destinatarioTags: ["Médicos", "Profesionales de la salud con carrera de grado", "Graduados UBA", "Graduados universidades argentinas", "Graduados universidades extranjeras"],
        director: ["Dr. Francisco Dadic"],
        directorDetalle: ["Director del Posgrado · (M.N. 125795) · Médico Toxicólogo · Fundación Iberoamericana de Salud Pública"],
        direccionAcademica: [
            { nombre: "Dr. Francisco Dadic", detalle: "Director del Posgrado · (M.N. 125795) · Médico Toxicólogo · Fundación Iberoamericana de Salud Pública" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dra.", nombre: "Banny Zelada (Bolivia)" },
            { titulo: "Dr.", nombre: "Jesús Boadas (República Dominicana)" },
            { titulo: "Mg.", nombre: "Ignacio Cichello" },
            { titulo: "Dr.", nombre: "Calle Mourin (Ecuador)" },
            { titulo: "Mg.", nombre: "Roberto Moro" },
            { titulo: "Lic.", nombre: "Facundo Prieto" },
            { titulo: "Lic.", nombre: "Natalia Giogia" },
            { titulo: "Dr.", nombre: "Diego Slipak" },
            { titulo: "Dr.", nombre: "Favio Orellana" },
            { titulo: "Dra.", nombre: "Giselle de Cou (Paraguay)" }
        ],
        directorImg: [dadic],
        inicio: "29/03/2027",
        fin: null,
        diasHorarios: "Lunes 18 a 20 hs",
        quincenal: false,
        clases: 34,
        horas: 370,
        duracion: 10,
        unidades: 6,
        destinatarios: "Dirigido a Médicos, profesionales de la salud y profesionales de otras carreras con título de grado. Obtendrán titulación FISP + Facultad de Medicina UBA.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a la carrera de Medicina",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Medicina"
        ],
        modalidad: "Virtual",
        temario: 23,
        precioArg: 3300000,
        precioArgDescuento: 2310000,
        precioCuotasArg: 275000,
        precioCuotasArgDescuento: 220000,
        precioExt: 2163.93,
        precioExtDescuento: 1514.75,
        precioCuotasExt: 180.33,
        precioCuotasExtDescuento: 144.26,
        cuotas: 12,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/2HenwtZ",
        linkpagoExt: "https://www.paypal.com/ncp/payment/KRHX6QFFMPWN4",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-85725694UC655532HNLJGERI",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 171,
        codigoT: "400.18",
        nombre: "Diplomatura en Criminalística y Ciencias Forenses",
        foto: forense,
        url: "diplomatura-criminalistica-ciencias-forenses",
        tipo: "Diplomatura",
        categoria: ["criminalistica"],
        area: "Criminalística / Forense",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Profesionales de la salud y estudiantes del último año vinculados al área salud, según los destinatarios del programa." },
            { certificacion: "FISP", aplicaA: "Profesionales de otras carreras, estudiantes u otros perfiles indicados en los destinatarios del programa." }
        ],
        descripcion: "La investigación de un hecho criminal reviste una importancia fundamental no solo para el esclarecimiento del mismo sino para proveer los servicios de justicia que demanda la sociedad, logrando satisfacer la obligación del Estado en materia de seguridad y prevención del delito.",
        descripcionExtra: ["La complejidad inherente a esta labor demanda una intervención técnico-científica de carácter interdisciplinario donde participan la criminología, la criminalística, la medicina legal y demás ciencias del espectro forense. Esta diplomatura busca proporcionar las herramientas teóricas y prácticas necesarias para abordar estas complejidades con rigurosidad, eficacia y compromiso ético."],
        descripcionPreview: "Formación interdisciplinaria en ciencias forenses, criminalística, medicina legal, tanatología, lesionología y patología forense.",
        sobreTitulo: "Investigación criminal con rigor científico",
        objetivos: ["Conocimiento y comprensión de las ciencias forenses, la criminalística, la medicina legal, la tanatología, la lesionología, la radiología y la patología forense.", "Desarrollar una visión integral en el abordaje de la investigación criminal.", "Conocimientos básicos en relación al estudio médico legal y criminalístico de las lesiones y de la muerte.", "Habilidades para desenvolverse en peritaciones vinculadas a abordajes criminalísticos, médico-legales y autopsias medicolegales."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Médicos", "Profesionales de la salud", "Estudiantes último año (Medicina)", "Profesionales de otras carreras", "Universidades argentinas y extranjeras"],
        director: ["Dr. Santiago Maffia Bizzozero"],
        directorDetalle: ["Director · (M.N. 109205) · Médico especialista en medicina legal · Director Médico de la morgue judicial de la Nación Argentina"],
        direccionAcademica: [
            { nombre: "Dr. Santiago Maffia Bizzozero", detalle: "Director · (M.N. 109205) · Médico especialista en medicina legal · Director Médico de la morgue judicial de la Nación Argentina" }
        ],
        codireccion: ["Dr. Alejandro E. Vega"],
        codireccionDetalle: ["Co-director de la Diplomatura"],
        codireccionAcademica: [
            { nombre: "Dr. Alejandro E. Vega", detalle: "Co-director de la Diplomatura" }
        ],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Matías E. Saldeña" },
            { titulo: "Dra.", nombre: "Matilde Buzzi" },
            { titulo: "Dr.", nombre: "Pablo Bustelo" },
            { titulo: "Dr.", nombre: "Alejandro E. Vega" },
            { titulo: "Bioq.", nombre: "Natalia Bardoni" },
            { titulo: "Lic.", nombre: "Sofía Egaña" },
            { titulo: "Lic.", nombre: "Belén Spada" },
            { titulo: "Lic.", nombre: "Abel I. Cunto" }
        ],
        directorImg: [maffia],
        inicio: "08/03/2027",
        fin: null,
        diasHorarios: "Lunes 20 a 22 hs",
        quincenal: false,
        clases: 18,
        horas: 170,
        duracion: 5,
        unidades: 11,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser graduado de la Universidad de Buenos Aires con título de grado correspondiente a la carrera de Medicina.",
            "b) Ser graduado de otras universidades argentinas con título de grado correspondiente a la carrera de Medicina.",
            "c) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Medicina.",
            "d) Ser estudiante regular del último año de la carrera de Medicina."
        ],
        modalidad: "Virtual",
        temario: 18,
        precioArg: 1387500,
        precioArgDescuento: 971250,
        precioCuotasArg: 231250,
        precioCuotasArgDescuento: 185000,
        precioExt: 909.84,
        precioExtDescuento: 636.89,
        precioCuotasExt: 151.64,
        precioCuotasExtDescuento: 121.31,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/32dBTJs",
        linkpagoExt: "https://www.paypal.com/ncp/payment/2ZXTHRS63WJ56",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-8UW3473162753125JNLJGFUI",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 161,
        codigoT: "400.17",
        nombre: "Diplomatura en Marketing Médico",
        foto: marketing,
        url: "diplomatura-marketing-medico",
        tipo: "Diplomatura",
        categoria: ["marketing"],
        area: "Marketing Médico",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Profesionales de la salud y estudiantes del último año vinculados al área salud, según los destinatarios del programa." },
            { certificacion: "FISP", aplicaA: "Profesionales de otras carreras, estudiantes u otros perfiles indicados en los destinatarios del programa." }
        ],
        descripcion: "El contexto actual de la salud se encuentra atravesado por transformaciones profundas: la digitalización de la información, el acceso masivo a contenidos médicos por parte de los pacientes, la creciente competitividad entre instituciones sanitarias y la necesidad de generar confianza en un entorno de sobreinformación.",
        descripcionExtra: ["El marketing médico se constituye como una disciplina estratégica que permite a los profesionales y organizaciones del sector diferenciarse, comunicar con claridad y sostener relaciones basadas en la confianza y la ética. La Diplomatura ofrece un espacio académico que articula teoría y práctica, con énfasis en la aplicación real y contextualizada de estrategias de marketing en el ámbito sanitario."],
        descripcionPreview: "Estrategias de marketing aplicadas al sector salud: marca personal, redes sociales, publicidad digital, IA y gestión de consultorios.",
        sobreTitulo: "Marketing estratégico para el sector salud",
        objetivos: ["Comprender los fundamentos del marketing aplicado al sector salud, diferenciando las particularidades de la comunicación sanitaria.", "Incorporar metodologías de diagnóstico estratégico (FODA, SMART, Canvas) aplicadas al campo sanitario.", "Desarrollar la marca personal y profesional en salud, fortaleciendo la identidad, tono de voz y valores diferenciales.", "Capacitar en el uso de herramientas digitales y presenciales de comunicación, fomentando un posicionamiento ético y sustentable.", "Analizar el comportamiento del paciente como usuario de servicios de salud en la era digital.", "Promover la innovación en la relación médico-paciente, incorporando casos reales de aciertos y errores."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Profesionales de la salud", "Estudiantes último año (salud)", "Profesionales de otras carreras", "Título secundario"],
        director: ["Lic. Aldana Daniela Farinelli"],
        directorDetalle: ["Directora de la Diplomatura · Lic. Comunicación Social · Directora Ejecutiva de FISP"],
        direccionAcademica: [
            { nombre: "Lic. Aldana Daniela Farinelli", detalle: "Directora de la Diplomatura · Lic. Comunicación Social · Directora Ejecutiva de FISP" }
        ],
        codireccion: ["Lic. María Paz Torres"],
        codireccionDetalle: ["Co-directora de la Diplomatura"],
        codireccionAcademica: [
            { nombre: "Lic. María Paz Torres", detalle: "Co-directora de la Diplomatura" }
        ],
        equipoDocente: [
            { titulo: "Lic.", nombre: "María Paz Torres" },
            { titulo: "Dra.", nombre: "Jimena Le Bellot" },
            { titulo: "Lic.", nombre: "Agustina Durigon" },
            { titulo: "Lic.", nombre: "Candela Burruchaga" },
            { titulo: "Docente", nombre: "Sofía Ciardelli" },
            { titulo: "Dr.", nombre: "Paolo Lauretta" },
            { titulo: "Dr.", nombre: "Diego Slipak" },
            { titulo: "Docente", nombre: "Zahira Díaz" },
            { titulo: "Docente", nombre: "Eliana Gagliano" }
        ],
        directorImg: [farinelli],
        inicio: "08/03/2027",
        fin: null,
        diasHorarios: "Lunes 18 a 20 hs",
        quincenal: false,
        clases: 16,
        horas: 170,
        duracion: 5,
        unidades: 13,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "Título secundario"
        ],
        modalidad: "Virtual",
        temario: 17,
        precioArg: 1125000,
        precioArgDescuento: 787500,
        precioCuotasArg: 187500,
        precioCuotasArgDescuento: 150000,
        precioExt: 737.70,
        precioExtDescuento: 516.39,
        precioCuotasExt: 122.95,
        precioCuotasExtDescuento: 98.36,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/2SDAf1k",
        linkpagoExt: "https://www.paypal.com/ncp/payment/XFU5PSXFKSZ7U",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-7BL2223516344925HNLJGGIQ",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 121,
        codigoT: "400.8",
        nombre: "Diplomatura en Enfermería Neurológica",
        foto: neurologica,
        url: "diplomatura-enfermeria-neurologica",
        tipo: "Diplomatura",
        categoria: ["enfermeria"],
        area: "Enfermería",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Licenciados en Enfermería y enfermeros profesionales, según los requisitos del programa." }
        ],
        descripcion: "La enfermería neurológica desempeña un rol vital en el cuidado de los pacientes con patologías neurológicas. Esta diplomatura ofrece a los profesionales de enfermería la oportunidad de adquirir los conocimientos y las habilidades necesarias para enfrentar este desafío y contribuir al bienestar de los pacientes neurológicos y sus familias.",
        descripcionExtra: [],
        descripcionPreview: "Formación especializada para profesionales de enfermería que buscan fortalecer el cuidado integral de pacientes neurológicos.",
        sobreTitulo: "Cuidados especializados para pacientes con patologías neurológicas",
        objetivos: [
            "Fortalecer la valoración neurológica y la planificación de cuidados de enfermería.",
            "Reconocer signos de alarma e intervenir ante urgencias y patologías neurológicas frecuentes.",
            "Aplicar cuidados especializados en pacientes neurocríticos, neuroquirúrgicos y con trastornos cognitivos.",
            "Desarrollar habilidades de liderazgo, psicoeducación y acompañamiento del paciente y su familia."
        ],
        sistemaEvaluacion: [
            "Un examen parcial",
            "Actividad en foro",
            "Entrega de trabajos prácticos",
            "Examen final"
        ],
        destinatarioTags: [
            "Licenciados en Enfermería",
            "Enfermeros profesionales"
        ],
        director: ["Lic. Esp. Leonardo De Vincentiis"],
        directorDetalle: ["(MN 72146) · Licenciado en Enfermería"],
        direccionAcademica: [
            { nombre: "Lic. Esp. Leonardo De Vincentiis", detalle: "(MN 72146) · Licenciado en Enfermería" }
        ],
        equipoDocente: [
            { titulo: "Lic.", nombre: "Maximiliano Santos" },
            { titulo: "Dr.", nombre: "Matías Alet" },
            { titulo: "Lic.", nombre: "María Florencia Díaz Gutierrez" },
            { titulo: "Lic.", nombre: "Nadia Tessore" },
            { titulo: "Lic.", nombre: "Marlene Liporace" },
            { titulo: "Lic. Esp.", nombre: "Cynthia De Armas" },
            { titulo: "Lic.", nombre: "María Mercedes Acuña" }
        ],
        genero: "",
        directorImg: [devicentiis],
        inicio: "17/03/2027",
        fin: null,
        diasHorarios: "Miércoles 19 a 21 hs",
        quincenal: false,
        clases: 18,
        horas: 170,
        duracion: 5,
        destinatarios: "Enfermeros Profesionales y Licenciados en Enfermería.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a la carrera de Licenciatura en Enfermería.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Licenciatura en Enfermería"
        ],
        modalidad: "Virtual",
        temario: 8,
        video: null,
        precioArg: 1300000,
        precioArgDescuento: 910000,
        precioCuotasArg: 216666.67,
        precioCuotasArgDescuento: 173334,
        precioExt: 852.46,
        precioExtDescuento: 596.72,
        precioCuotasExt: 142.08,
        precioCuotasExtDescuento: 113.66,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/2ErKySo",
        linkpagoExt: "https://www.paypal.com/ncp/payment/AYXS5X8TP8CWN",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-1TG4722736959862NNLJGHLY",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 131,
        codigoT: "400.13",
        nombre: "Diplomatura en Inteligencia Artificial Médica",
        foto: ia,
        url: "diplomatura-ia-medica",
        tipo: "Diplomatura",
        categoria: ["tecnologia", "medicina-de-precision"],
        area: "IA Médica",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Profesionales de la salud y estudiantes del último año vinculados al área salud, según los destinatarios del programa." },
            { certificacion: "FISP", aplicaA: "Profesionales de otras carreras, estudiantes u otros perfiles indicados en los destinatarios del programa." }
        ],
        descripcion: "Las ciencias médicas se enfrentan a grandes y crecientes retos: el gasto en salud aumentó un 40% entre 2018 y 2022, la escasez de personal de salud lleva a la sobrecarga del personal existente, y el envejecimiento poblacional incrementa la demanda de atención.",
        descripcionExtra: ["La Inteligencia Artificial representa no solo un avance tecnológico prometedor, sino una posible respuesta a múltiples problemáticas. La OMS reconoce su valor y juega un papel activo en convertirla en una herramienta integrada de los sistemas de salud. Hoy la IA se encuentra en práctica clínica, investigación biomédica, salud pública y administración."],
        descripcionPreview: "Desde los fundamentos de la IA hasta su aplicación en diagnóstico, cirugía, oncología e investigación biomédica.",
        sobreTitulo: "La IA como respuesta a los desafíos de la salud",
        objetivos: ["Brindar conocimientos fundamentales y sólidos sobre IA, desde sus fundamentos básicos hasta su aplicación en salud.", "Aportar los conocimientos necesarios para la elaboración y planeamiento de proyectos en IA.", "Equipar al profesional con herramientas para planificar y ejecutar proyectos innovadores en IA dentro del sector sanitario."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Profesionales de la salud", "Estudiantes último año (salud)", "Profesionales de otras carreras", "Estudiantes último año (otras)"],
        director: ["Dr. Paolo Lauretta"],
        directorDetalle: ["Director de Salud Digital de FISP · Artificial Intelligence in Health Care (MIT)"],
        direccionAcademica: [
            { nombre: "Dr. Paolo Lauretta", detalle: "Director de Salud Digital de FISP · Artificial Intelligence in Health Care (MIT)" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Santiago Maffia" },
            { titulo: "Ing.", nombre: "Alberto Ortega" },
            { titulo: "Dra.", nombre: "Karina Formoso" },
            { titulo: "Dra.", nombre: "Jesica Formoso" }
        ],
        directorImg: [lauretta],
        inicio: "09/03/2027",
        fin: null,
        diasHorarios: "Martes 20 a 22 hs",
        quincenal: false,
        clases: 18,
        horas: 170,
        duracion: 5,
        unidades: 9,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado",
            "b) Ser graduado de universidades extranjeras con título de grado",
            "c) Ser estudiante regular de último año de carrera."
        ],
        modalidad: "Virtual",
        temario: 13,
        precioArg: 1875000,
        precioArgDescuento: 1312500,
        precioCuotasArg: 312500,
        precioCuotasArgDescuento: 250000,
        precioExt: 1229.51,
        precioExtDescuento: 860.66,
        precioCuotasExt: 204.92,
        precioCuotasExtDescuento: 163.94,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/2yq7dXA",
        linkpagoExt: "https://www.paypal.com/ncp/payment/9LZFT8GZDWYVQ",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-9AT68626XG900973MNLJGIEA",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 133,
        codigoT: "400.15",
        nombre: "Diplomatura en Gestión de Sistemas de Telemedicina",
        foto: telemedicina,
        url: "diplomatura-gestion-telemedicina",
        tipo: "Diplomatura",
        categoria: ["tecnologia"],
        area: "Telemedicina",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "El avance exponencial de los medios de comunicación, internet y dispositivos electrónicos ha revolucionado las formas de interacción en la sociedad, convirtiendo el uso de la tecnología en un hábito e incluso una necesidad. En este contexto, es de gran importancia capacitar a los profesionales en sistemas de telemedicina.",
        descripcionExtra: [],
        descripcionPreview: "Formación en sistemas de telemedicina y herramientas digitales para transformar la interacción y la atención en salud.",
        sobreTitulo: "Tecnología, gestión y atención sanitaria a distancia",
        objetivos: [
            "Comprender los fundamentos, alcances y modalidades de la telemedicina.",
            "Seleccionar e implementar tecnologías seguras para teleconsulta, telemonitoreo y telediagnóstico.",
            "Aplicar criterios legales, éticos y de protección de datos en la atención a distancia.",
            "Diseñar y evaluar programas de telemedicina sostenibles en instituciones públicas y privadas."
        ],
        sistemaEvaluacion: [
            "Dos exámenes parciales",
            "Examen final",
            "Práctica supervisada y visita a un centro de monitoreo en telemedicina"
        ],
        destinatarioTags: [
            "Médicos",
            "Profesionales de la salud",
            "Profesionales de otras carreras con título de grado"
        ],
        director: ["Dr. Gustavo Giarratana"],
        directorDetalle: ["Director de la Diplomatura"],
        direccionAcademica: [
            { nombre: "Dr. Gustavo Giarratana", detalle: "Director de la Diplomatura" }
        ],
        equipoDocente: [
            { titulo: "Dr.", nombre: "German Nestasio" },
            { titulo: "Dr.", nombre: "Diego Slipak" },
            { titulo: "Dr.", nombre: "Paolo Lauretta" }
        ],
        genero: "",
        directorImg: [giarratana],
        inicio: "16/03/2027",
        fin: null,
        diasHorarios: "Martes 19 a 21 hs",
        quincenal: false,
        clases: 18,
        horas: 170,
        duracion: 5,
        destinatarios: "Dirigido a médicos, profesionales de la salud y profesionales de otras carreras con título de grado. Titulación: FISP + UBA.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a una profesión relacionada a la salud.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a una profesión relacionada a la salud.",
            "c) Ser graduado de universidades argentinas con título de otras carreras profesionales.",
            "d) Ser graduado de universidades extranjeras de otras carreras profesionales."
        ],
        modalidad: "Virtual",
        temario: 15,
        video: VideoTelemedicina,
        precioArg: 1275000,
        precioArgDescuento: 892500,
        precioCuotasArg: 212500,
        precioCuotasArgDescuento: 170000,
        precioExt: 836.07,
        precioExtDescuento: 585.25,
        precioCuotasExt: 139.34,
        precioCuotasExtDescuento: 111.47,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/24cQLSX",
        linkpagoExt: "https://www.paypal.com/ncp/payment/P8U6J82RQRKU2",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-44H5548744840241FNLJGJTY",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 102,
        codigoT: "400.2",
        nombre: "Diplomatura en Bioremodelación Facial",
        foto: bioFacial,
        url: "diplomatura-bioremodelacion-facial",
        tipo: "Diplomatura",
        categoria: ["dermatologia"],
        area: "Estética",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Se estudia la anatomía facial, la estructura y función de los músculos faciales, los puntos de inyección, la anatomía vascular e inervación del rostro. Se exploran los mecanismos de acción de la toxina botulínica tipo A, las dosis adecuadas, reconstitución y precauciones.",
        descripcionExtra: ["Se enseñan las técnicas adecuadas para administrar toxina botulínica A y los diferentes tipos de implantes de ácido hialurónico y fillers semipermanentes. Se aprende a evaluar pacientes, identificar necesidades estéticas y diseñar planes de tratamiento personalizados, incluyendo el manejo de complicaciones."],
        descripcionPreview: "Toxina botulínica, ácido hialurónico, fillers, rinoremodelación y tratamientos complementarios con formación teórica y práctica.",
        sobreTitulo: "Dominio integral de la bioremodelación facial",
        objetivos: ["Adquirir conocimientos teóricos sobre anatomía facial, farmacología de la toxina botulínica tipo A y técnicas de inyección.", "Aprender a evaluar pacientes, identificar necesidades y diseñar planes de tratamientos individualizados.", "Familiarizarse con precauciones, medidas de seguridad y manejo de posibles complicaciones.", "Optimizar el conocimiento de ácido hialurónico, hidroxiapatita de calcio y fillers semipermanentes."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Trabajos prácticos", "Examen final"],
        destinatarioTags: ["Médicos/as", "Odontólogos/as", "Estudiantes último año (Medicina/Odontología)"],
        director: ["Dr. Alfredo Ruiz Díaz"],
        directorDetalle: ["Director de la Diplomatura"],
        direccionAcademica: [
            { nombre: "Dr. Alfredo Ruiz Díaz", detalle: "Director de la Diplomatura" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Diego Slipak" },
            { titulo: "Dra.", nombre: "Sylvia B. Pingitore" }
        ],
        directorImg: [diaz],
        codireccionImg: [],
        inicio: "10/03/2027",
        fin: null,
        "practica final": null,
        diasHorarios: "Miércoles 20 a 22 hs",
        quincenal: false,
        clases: 17,
        horas: 170,
        duracion: 5,
        unidades: 16,
        destinatarios: "Dirigido a Médicos, profesionales de la salud y profesionales de otras carreras con título de grado. Obtendrán titulación FISP + Facultad de Medicina UBA.",
        requisitos: [
            "a) Ser graduado de la Universidad de Buenos Aires con título de grado correspondiente a la carrera de Medicina u Odontología.",
            "b) Ser graduado de otras universidades argentinas con título de grado correspondiente a la carrera de Medicina u Odontología.",
            "c) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Medicina u Odontología.",
            "d) Ser estudiante regular del último año de la carrera de Medicina u Odontología."
        ],
        modalidad: "Clases virtuales + Prácticas finales",
        temario: 2,
        precioArg: 2250000,
        precioArgDescuento: 1575000,
        precioCuotasArg: 375000,
        precioCuotasArgDescuento: 300000,
        precioExt: 1475.41,
        precioExtDescuento: 1032.79,
        precioCuotasExt: 245.90,
        precioCuotasExtDescuento: 196.72,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/2K9nE1a",
        linkpagoExt: "https://www.paypal.com/ncp/payment/EZ4QFAVRQJU88",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-68V79296GE337290TNLJGL2I",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 103,
        codigoT: "400.3",
        nombre: "Diplomatura en Medicina de las Adicciones",
        foto: adicciones,
        url: "diplomatura-medicina-adicciones",
        tipo: "Diplomatura",
        categoria: ["salud-mental-y-adicciones", "psiquiatria"],
        area: "Adicciones",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Las adicciones conllevan un patrón de funcionamiento desadaptativo de consumo que provoca malestar o deterioro significativo. Cuando se habla de drogas, se hace referencia a toda aquella sustancia que, una vez consumida, modifica las funciones del organismo a nivel físico o mental.",
        descripcionExtra: ["Esta diplomatura brinda un análisis exhaustivo abordando la conceptualización de las drogas, la psicobiología de las adicciones y los daños producidos por el consumo. Se profundiza en sustancias específicas —alcohol, tabaco, estimulantes, cannabis, alucinógenos, inhalantes, opiáceos, sedantes y ansiolíticos— y se exploran la adicción tecnológica y el juego patológico, con herramientas concretas para la prevención y el tratamiento."],
        descripcionPreview: "Análisis de las adicciones, su psicobiología, sustancias específicas, adicción tecnológica, juego patológico y abordaje clínico.",
        sobreTitulo: "Un abordaje integral de las adicciones",
        objetivos: ["Comprender la psicobiología de las adicciones, el sistema de recompensa cerebral y los mecanismos neurobiológicos de la conducta adictiva.", "Identificar y clasificar las distintas sustancias psicoactivas, sus efectos agudos y crónicos, y su abordaje según el DSM.", "Desarrollar habilidades clínicas para el diagnóstico, tratamiento interdisciplinario y prevención de las adicciones en distintas poblaciones.", "Explorar las nuevas formas de adicción —tecnológica y juego patológico— y comprender su impacto en ámbitos laborales, familiares y sociales."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Médicos", "Estudiantes último año de Medicina", "Graduados UBA", "Graduados universidades argentinas", "Graduados universidades extranjeras"],
        director: ["Dr. Francisco Dadic"],
        directorDetalle: ["Director de la Diplomatura"],
        direccionAcademica: [
            { nombre: "Dr. Francisco Dadic", detalle: "Director de la Diplomatura" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Antonio Pascale" },
            { titulo: "Dr.", nombre: "Pablo Fielitz" },
            { titulo: "Dr.", nombre: "Eduardo Henderson" }
        ],
        directorImg: [dadic],
        inicio: "08/03/2027",
        fin: null,
        diasHorarios: "Lunes 19 a 21 hs",
        quincenal: false,
        clases: 16,
        horas: 170,
        duracion: 5,
        unidades: 18,
        destinatarios: "Dirigido a Médicos, profesionales de la salud y profesionales de otras carreras con título de grado. Obtendrán titulación FISP + Facultad de Medicina UBA.",
        requisitos: [
            "a) Ser graduado de la Universidad de Buenos Aires con título de grado correspondiente a la carrera de Medicina",
            "b) Ser graduado de la Universidad de otras universidades argentinas con título de grado correspondiente a la carrera de Medicina",
            "c) Ser graduado de Universidades extranjeras con título de grado correspondiente a la carrera de Medicina",
            "d) Ser estudiante regular de último año de la carrera de Medicina."
        ],
        modalidad: "Virtual",
        temario: 3,
        precioArg: 1275000,
        precioArgDescuento: 892500,
        precioCuotasArg: 212500,
        precioCuotasArgDescuento: 170000,
        precioExt: 836.07,
        precioExtDescuento: 585.25,
        precioCuotasExt: 139.34,
        precioCuotasExtDescuento: 111.47,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/2xrvqUA",
        linkpagoExt: "https://www.paypal.com/ncp/payment/48WKGDZR238UW",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-3K746985VR486715MNLJGMUA",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 111,
        codigoT: "400.4",
        nombre: "Diplomatura en Nutrición Deportiva de Alto Rendimiento",
        foto: nutriDeportiva,
        url: "diplomatura-nutricion-deportiva",
        tipo: "Diplomatura",
        categoria: ["nutricion"],
        area: "Nutrición",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Profesionales de la salud y estudiantes del último año vinculados al área salud, según los destinatarios del programa." },
            { certificacion: "FISP", aplicaA: "Profesionales de otras carreras, estudiantes u otros perfiles indicados en los destinatarios del programa." }
        ],
        descripcion: "Hoy en día sabemos que la práctica del ejercicio físico es fundamental para mejorar nuestra calidad de vida. Una dieta equilibrada es uno de los pilares para mantener un estilo de vida saludable y un rendimiento óptimo en cada actividad. El correcto asesoramiento nutricional junto a un adecuado plan alimentario mejorará ampliamente el rendimiento físico.",
        descripcionExtra: ["En esta Diplomatura contamos con un programa integral basado en las últimas actualizaciones científicas en el área de nutrición y salud deportiva. Brindaremos a cada alumno el conocimiento necesario para su correcta práctica diaria, tanto profesional como deportiva en cada disciplina."],
        descripcionPreview: "Formación en nutrición deportiva: bases moleculares, suplementación, metabolismo muscular y planificación para el alto rendimiento.",
        sobreTitulo: "Nutrición y rendimiento: el binomio del alto rendimiento",
        objetivos: ["Brindar los conocimientos actualizados sobre nutrición aplicada al deporte, con base en las últimas evidencias científicas.", "Conocer la estructura del músculo esquelético, comprendiendo su funcionamiento en profundidad y su relación con el rendimiento.", "Comprender los factores externos e internos que influyen en el abordaje nutricional individualizado de cada deportista.", "Capacitar para el correcto establecimiento de un plan de alimentación teniendo en cuenta la actividad específica a desarrollar."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Profesionales de la salud", "Estudiantes último año (salud)", "Profesionales de otras carreras", "Estudiantes universitarios", "Con título secundario"],
        director: ["Dra. Elena Pastor Manfredi"],
        directorDetalle: ["Directora · (MN 163753) · Especialista en Nutrición"],
        direccionAcademica: [
            { nombre: "Dra. Elena Pastor Manfredi", detalle: "Directora · (MN 163753) · Especialista en Nutrición" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Patricio Izal" },
            { titulo: "Prof.", nombre: "Soledad Álvarez" },
            { titulo: "Lic.", nombre: "Laura Iermoli" },
            { titulo: "Dr.", nombre: "Raúl F. Pastor" }
        ],
        directorImg: [manfredi],
        inicio: "12/03/2027",
        fin: null,
        diasHorarios: "Viernes 18 a 20 hs",
        quincenal: false,
        clases: 18,
        horas: 170,
        duracion: 5,
        unidades: 10,
        destinatarios: "Dirigido a Licenciadas/os en Nutrición y otros profesionales de la salud que requieran conocimiento sobre nutrición para la práctica profesional.",
        requisitos: ["Titulo Secundario"],
        modalidad: "Virtual",
        temario: 4,
        precioArg: 1215000,
        precioArgDescuento: 850500,
        precioCuotasArg: 202500,
        precioCuotasArgDescuento: 162000,
        precioExt: 796.72,
        precioExtDescuento: 557.70,
        precioCuotasExt: 132.79,
        precioCuotasExtDescuento: 106.23,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/1YGGiZa",
        linkpagoExt: "https://www.paypal.com/ncp/payment/PSLAYHWC2MH9S",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-4TC19385UT377321YNLJGNWA",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 101,
        codigoT: "400.1",
        nombre: "Diplomatura en Urgencias Neurocardiológicas",
        foto: neurocardio,
        url: "diplomatura-urgencias-neurocardiologicas",
        tipo: "Diplomatura",
        categoria: ["neurocardiologia"],
        area: "Neurocardiología",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La enfermedad cardiovascular es la primera causa de mortalidad a nivel mundial, y en Argentina el 25% de las muertes son atribuibles a enfermedades del sistema circulatorio. El accidente cerebrovascular, por su parte, es la primera causa de discapacidad a nivel global, y la OMS estima un aumento del 20% en su incidencia para 2040.",
        descripcionExtra: ["Esta diplomatura forma profesionales con competencias esenciales para la identificación temprana, evaluación precisa y aplicación de intervenciones urgentes en situaciones neurocardiológicas críticas. La interconexión entre los sistemas cardiovascular y neurovascular exige un enfoque multidisciplinario, colaborativo y basado en la evidencia más actualizada."],
        descripcionPreview: "Formación avanzada para el manejo de emergencias cardiovasculares y neurovasculares: infarto, ACV, arritmias y shock cardiogénico.",
        sobreTitulo: "Urgencias neurocardiológicas: una necesidad crítica",
        objetivos: ["Proporcionar conocimientos sólidos sobre bases teóricas y prácticas de las urgencias neurocardiológicas para mejorar la comprensión integral de estas situaciones críticas.", "Desarrollar habilidades clínicas avanzadas: evaluación rápida, diagnóstico preciso y aplicación de protocolos de tratamiento actualizados.", "Capacitar en la identificación temprana de signos y síntomas e interpretación de pruebas diagnósticas para optimizar los tiempos de intervención.", "Fomentar el trabajo interdisciplinario y la comunicación efectiva para mejorar la coordinación y la calidad de la atención en urgencias.", "Desarrollar habilidades de liderazgo y toma de decisiones efectivas en situaciones de urgencias neuro-cardio-vasculares.", "Actualizar en los avances tecnológicos y terapéuticos del campo, integrando las últimas evidencias científicas en la práctica clínica."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Médicos Cardiólogos", "Médicos Neurólogos", "Médicos Clínicos", "Especialistas en Terapia Intensiva", "Médicos Emergentólogos", "Médicos de Familia", "Estudiantes último año de Medicina"],
        director: ["Dr. Matías J. Alet"],
        directorDetalle: ["Director · (M.N. 137234) · Neurólogo"],
        direccionAcademica: [
            { nombre: "Dr. Matías J. Alet", detalle: "Director · (M.N. 137234) · Neurólogo" }
        ],
        codireccion: ["Dra. Natalia Zareba"],
        codireccionDetalle: ["Co-directora de la Diplomatura"],
        codireccionAcademica: [
            { nombre: "Dra. Natalia Zareba", detalle: "Co-directora de la Diplomatura" }
        ],
        equipoDocente: [
            { titulo: "Dra.", nombre: "Julieta Rosales" },
            { titulo: "Dr.", nombre: "Ignacio Petel" },
            { titulo: "Dra.", nombre: "Agustina Zavattieri" },
            { titulo: "Dra.", nombre: "Jimena Gambarte" },
            { titulo: "Dra.", nombre: "Mariana Mazzei" },
            { titulo: "Dr.", nombre: "Ignacio Rios" },
            { titulo: "Dra.", nombre: "Sofia Razzini" },
            { titulo: "Dr.", nombre: "Herrera Paz" }
        ],
        directorImg: [alet],
        codireccionImg: [zareba],
        inicio: "19/03/2027",
        fin: null,
        diasHorarios: "Viernes 19 a 21 hs",
        quincenal: false,
        clases: 18,
        horas: 170,
        duracion: 5,
        unidades: 10,
        destinatarios: "Dirigido a Médicos, profesionales de la salud y profesionales de otras carreras con título de grado. Obtendrán titulación FISP + Facultad de Medicina UBA.",
        requisitos: [
            "a) Ser graduado de la Universidad de Buenos Aires con título de grado correspondiente a la carrera de Medicina.",
            "b) Ser graduado de otras universidades argentinas con título de grado correspondiente a la carrera de Medicina.",
            "c) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Medicina.",
            "d) Ser estudiante regular del último año de la carrera de Medicina."
        ],
        modalidad: "Virtual",
        temario: 1,
        precioArg: 1275000,
        precioArgDescuento: 892500,
        precioCuotasArg: 212500,
        precioCuotasArgDescuento: 170000,
        precioExt: 836.07,
        precioExtDescuento: 585.25,
        precioCuotasExt: 139.34,
        precioCuotasExtDescuento: 111.47,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/23YiRXR",
        linkpagoExt: "https://www.paypal.com/ncp/payment/5GVQJ66ZA8Y5C",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-1VB006252R043451BNLJGORQ",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 123,
        codigoT: "400.10",
        nombre: "Diplomatura en Enfermería de Consumos Problemáticos",
        foto: consumos,
        url: "diplomatura-enfermeria-consumos-problematicos",
        tipo: "Diplomatura",
        categoria: ["enfermeria", "salud-mental-y-adicciones"],
        area: "Enfermería",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La enfermería cumple un rol clave en la detección temprana, el abordaje y la recuperación de personas con consumo problemático de sustancias. Esta diplomatura te brinda herramientas actualizadas para intervenir con eficacia, sensibilidad y visión interdisciplinaria.",
        descripcionExtra: [],
        descripcionPreview: "Formación para la atención integral de pacientes con consumo problemático de sustancias desde el rol profesional de enfermería.",
        sobreTitulo: "",
        objetivos: [
            "Capacitar a los profesionales de enfermería en el abordaje integral del consumo problemático de sustancias, desarrollando competencias para su identificación, evaluación, diagnóstico y planificación de cuidados.",
            "Implementar intervenciones terapéuticas, estrategias de reducción de daños y atención de urgencias y emergencias asociadas.",
            "Promover una práctica basada en la evidencia científica, el enfoque ético y de derechos humanos, y el trabajo interdisciplinario.",
            "Fortalecer las acciones de prevención, tratamiento y acompañamiento en los ámbitos sanitarios y comunitarios."
        ],
        sistemaEvaluacion: [
            "Un examen parcial",
            "Actividad en foro",
            "Entrega de trabajos prácticos",
            "Examen final"
        ],
        destinatarioTags: ["Licenciados en Enfermería", "Enfermeros profesionales"],
        director: ["Lic. Esp. Leonardo De Vincentiis"],
        directorDetalle: ["(MN 72146) · Licenciado en Enfermería"],
        direccionAcademica: [
            { nombre: "Lic. Esp. Leonardo De Vincentiis", detalle: "(MN 72146) · Licenciado en Enfermería" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Francisco Dadic" },
            { titulo: "Lic.", nombre: "Juliana Lanza" },
        ],
        directorImg: [devicentiis],
        inicio: "18/03/2027",
        fin: null,
        diasHorarios: "Jueves 19 a 21 hs",
        quincenal: false,
        clases: 18,
        horas: 170,
        duracion: 5,
        unidades: null,
        destinatarios: "Dirigido a Licenciados en Enfermería y Enfermeros profesionales.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a la carrera de Enfermería.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Enfermería"
        ],
        modalidad: "Virtual",
        temario: 10,
        precioArg: 1012500,
        precioArgDescuento: 708750,
        precioCuotasArg: 168750,
        precioCuotasArgDescuento: 135000,
        precioExt: 663.93,
        precioExtDescuento: 464.75,
        precioCuotasExt: 110.66,
        precioCuotasExtDescuento: 88.53,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/12iyxSD",
        linkpagoExt: "https://www.paypal.com/ncp/payment/ECDZWYHEUAJ3S",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-14246348JB620743CNLJGPMQ",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 151,
        codigoT: "400.16",
        nombre: "Diplomatura en Ginecología Regenerativa, Estética y Funcional",
        foto: ginecologia,
        url: "diplomatura-ginecologia-regenerativa-estetica-funcional",
        tipo: "Diplomatura",
        categoria: ["ginecologia"],
        area: "Ginecología Regenerativa",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La ginecología regenerativa, estética y funcional representa una evolución en la atención de la salud íntima femenina, respondiendo a una creciente demanda de tratamientos que aborden no sólo patologías, sino también aspectos funcionales y estéticos que impactan significativamente la calidad de vida y la autoestima de las mujeres.",
        descripcionExtra: ["Esta diplomatura surge para llenar la brecha en la formación tradicional, ofreciendo una capacitación integral y especializada que abarca desde la fisiología del envejecimiento genital y la microbiota, hasta el dominio de terapias bioregenerativas, inyectables, energéticas y procedimientos quirúrgicos mínimamente invasivos."],
        descripcionPreview: "Terapias bioregenerativas, inyectables, energéticas y cirugía cosmetoginecológica para el abordaje integral de la salud íntima femenina.",
        sobreTitulo: "Evolución en la atención de la salud íntima femenina",
        objetivos: ["Integrar conocimientos estéticos, funcionales y regenerativos en el abordaje ginecológico, optimizando la función genital femenina.", "Abordar de manera integral los trastornos del suelo pélvico, el disconfort vulvar y el impacto en la calidad de vida sexual.", "Valorar la importancia de la ginecoestética en su aspecto funcional y estético para evaluación, diagnóstico y tratamiento.", "Desarrollar criterio clínico para seleccionar estrategias terapéuticas priorizando seguridad, evidencia y bienestar de la paciente."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Ginecología", "Tocoginecología", "Obstetricia", "Urología", "Residentes último año"],
        director: ["Dra. Camila Enei"],
        directorDetalle: ["Directora · (MN 166563) · Tocoginecóloga"],
        direccionAcademica: [
            { nombre: "Dra. Camila Enei", detalle: "Directora · (MN 166563) · Tocoginecóloga" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dra.", nombre: "Cecilia Ruiz" },
            { titulo: "Dra.", nombre: "Barbara Durand" },
            { titulo: "Dra.", nombre: "Maria Denari" },
            { titulo: "Dra.", nombre: "Gisella Perochena" },
            { titulo: "Dra.", nombre: "Melania Thiermann" },
            { titulo: "Dra.", nombre: "Mercedes Fiuza" },
            { titulo: "Dra.", nombre: "Macarena Alimón" }
        ],
        directorImg: [enei],
        inicio: "09/03/2027",
        fin: null,
        diasHorarios: "Martes 18 a 20 hs",
        quincenal: false,
        clases: 18,
        horas: 170,
        duracion: 5,
        unidades: 10,
        destinatarios: "Dirigido a Médicos, profesionales de la salud y profesionales de otras carreras con título de grado. Obtendrán titulación FISP + Facultad de Medicina UBA.",
        requisitos: [
            "a) Ser médico graduado de la Universidad de Buenos Aires con título habilitante y formación de posgrado (especialidad finalizada o en curso en el último año de residencia) en Ginecología, Tocoginecología, Obstetricia o Urología.",
            "b) Ser médico graduado de otras universidades argentinas con título habilitante y formación de posgrado (especialidad finalizada o en curso en el último año de residencia) en Ginecología, Tocoginecología, Obstetricia o Urología.",
            "c) Ser médico graduado de universidades extranjeras con título habilitante y formación de posgrado (especialidad finalizada o en curso en el último año de residencia) en Ginecología, Tocoginecología, Obstetricia o Urología."
        ],
        modalidad: "Virtual",
        temario: 16,
        precioArg: 1762500,
        precioArgDescuento: 1233750,
        precioCuotasArg: 293750,
        precioCuotasArgDescuento: 235000,
        precioExt: 1155.74,
        precioExtDescuento: 809.02,
        precioCuotasExt: 192.62,
        precioCuotasExtDescuento: 154.10,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/2vBEMDF",
        linkpagoExt: "https://www.paypal.com/ncp/payment/3B6UNNV6M48QE",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-0XW80925RT4886501NLJGP7Q",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 113,
        codigoT: "400.6",
        nombre: "Diplomatura en Nutrición y Diabetes Tipo 2",
        foto: diabetes,
        url: "diplomatura-nutricion-diabetes",
        tipo: "Diplomatura",
        categoria: ["nutricion"],
        area: "Nutrición",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La nutrición tiene un papel fundamental en el estado de salud de las personas, sobre todo cuando padecen algún tipo de patología. Por lo cual, es necesario que los profesionales alcancen un dominio elevado en esta área, manteniendo de forma permanente una puesta al día que permita evaluar un tratamiento terapéutico adecuado para cada individuo.",
        descripcionExtra: ["Contamos con un programa completo mediante el cual, cada profesional recibirá todo el conocimiento actualizado y necesario sobre la nutrición clínica, pudiendo abordar cada paciente de una forma integral y personalizada."],
        descripcionPreview: "Nutrición clínica para el abordaje integral de la diabetes tipo 2: fisiopatología, farmacología y planes nutricionales personalizados.",
        sobreTitulo: "Nutrición clínica al servicio del paciente con diabetes",
        objetivos: ["Brindar los conocimientos científicos actualizados sobre diabetes tipo 2: fisiopatología, bioquímica, metabolismo y etiopatogenia.", "Establecer un programa de tratamiento que incluya a todo el equipo de salud: cambios de estilo de vida, educación terapéutica y estrategias de adherencia.", "Aportar herramientas para favorecer la adherencia sobre los cambios necesarios en el estilo de vida del paciente con DBT tipo 2.", "Capacitar en el diseño de planes nutricionales personalizados, integrando el abordaje farmacológico y no farmacológico de la patología."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Licenciadas/os en Nutrición", "Médicos", "Graduados UBA", "Otras universidades argentinas", "Universidades extranjeras"],
        director: ["Dra. Elena Pastor Manfredi"],
        directorDetalle: ["Directora · (MN 163.753) · Especialista en Nutrición"],
        direccionAcademica: [
            { nombre: "Dra. Elena Pastor Manfredi", detalle: "Directora · (MN 163.753) · Especialista en Nutrición" }
        ],
        codireccion: ["Prof. Dr. Raúl F. Pastor"],
        codireccionDetalle: ["Co-Director de la Diplomatura"],
        codireccionAcademica: [
            { nombre: "Prof. Dr. Raúl F. Pastor", detalle: "Co-Director de la Diplomatura" }
        ],
        equipoDocente: [
            { titulo: "Lic.", nombre: "Laura Iermoli" }
        ],
        directorImg: [manfredi],
        codireccionImg: [pastor],
        inicio: "11/03/2027",
        fin: null,
        diasHorarios: "Jueves 20 a 22 hs",
        quincenal: true,
        clases: 18,
        horas: 170,
        duracion: 5,
        unidades: 8,
        destinatarios: "Dirigido a Licenciadas/os en Nutrición y otros profesionales de la salud que requieran conocimiento sobre nutrición para la práctica profesional.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a una profesión relacionada a la salud.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a una profesión relacionada a la salud."
        ],
        modalidad: "Virtual",
        temario: 6,
        precioArg: 1200000,
        precioArgDescuento: 840000,
        precioCuotasArg: 200000,
        precioCuotasArgDescuento: 160000,
        precioExt: 786.89,
        precioExtDescuento: 550.82,
        precioCuotasExt: 131.15,
        precioCuotasExtDescuento: 104.92,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/2S7X19G",
        linkpagoExt: "https://www.paypal.com/ncp/payment/C8KLCW6C8GGKE",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-0H251798WP7592923NLJGQVQ",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 141,
        codigoT: "400.35",
        nombre: "Diplomatura en Medicina Laboral Especializada en Energía y Minería",
        foto: medicinaLaboral,
        url: "diplomatura-medicina-laboral-energia-mineria",
        tipo: "Diplomatura",
        categoria: ["medicina-laboral"],
        area: "Medicina Laboral",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La diplomatura aborda el contexto del trabajo en hidrocarburos y minería, los agentes de riesgo del sector, el diagnóstico clínico y el nexo causal, junto con las herramientas de vigilancia, prevención y el marco legal que encuadra la práctica profesional.",
        descripcionExtra: [
            "El eje de territorio atraviesa todos los módulos: emergencias médicas en campo, gestión del enfermo crónico alejado del centro de salud y telemedicina en zonas remotas.",
            "Formación integral en toxicología industrial, enfermedades profesionales, vigilancia médica, emergencias en campo y marco legal del sector extractivo."
        ],
        descripcionPreview: "Toxicología industrial, enfermedades profesionales, vigilancia médica, emergencias, telemedicina y marco legal del sector.",
        sobreTitulo: "El médico en la industria extractiva",
        objetivos: [
            "Comprender el contexto, magnitud y particularidades del trabajo en hidrocarburos y minería, incluyendo Vaca Muerta y la minería metalífera.",
            "Dominar la toxicología de los principales agentes de riesgo: benceno, sílice, H2S, NORM, ruido industrial y estrés térmico.",
            "Diagnosticar enfermedades profesionales, establecer nexo causal y documentar informes médico-legales con criterios de Bradford Hill.",
            "Manejar emergencias médicas e industriales en campo, telemedicina en zonas remotas y criterios de evacuación."
        ],
        sistemaEvaluacion: [
            "Evaluación integradora asincrónica por módulo (cuestionario + caso clínico)",
            "Actividad en foro",
            "Trabajo final integrador (Módulo 9)",
            "Aprobación: 70% de cada módulo + presentación del trabajo final"
        ],
        destinatarioTags: [
            "Médicos laborales",
            "Médicos auditores",
            "Médicos de empresa (extractivos)",
            "Higiene y seguridad",
            "Médicos generalistas"
        ],
        director: ["Dr. Juan Carchini"],
        directorDetalle: ["Director Médico de FISP · (M.N. 111923)"],
        direccionAcademica: [
            { nombre: "Dr. Juan Carchini", detalle: "Director Médico de FISP · (M.N. 111923)" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            {
                titulo: "Dr.",
                nombre: "Sergio Santillán",
                detalle: "Médico laboral especialista en yacimientos y mineras",
            },
            {
                titulo: "Dr.",
                nombre: "Nazario Boldo",
                detalle: "Médico Psiquiatra y Legista en riesgos del trabajo",
            },
            {
                titulo: "Dr.",
                nombre: "Francisco Dadic",
                detalle: "Director de Toxicología de FISP",
            },
        ],
        directorImg: [carchini],
        inicio: "30/03/2027",
        fin: null,
        diasHorarios: "Martes 20 a 22 hs",
        quincenal: false,
        clases: 38,
        horas: 170,
        duracion: 5,
        unidades: 9,
        destinatarios: "Dirigido a Médicos, profesionales de la salud y profesionales de otras carreras con título de grado. Obtendrán titulación FISP + Facultad de Medicina UBA.",
        requisitos: [null],
        modalidad: "Virtual",
        temario: 32,
        precioArg: 1815000,
        precioArgDescuento: 1270500,
        precioCuotasArg: 302500,
        precioCuotasArgDescuento: 242000,
        precioExt: 1190.16,
        precioExtDescuento: 833.11,
        precioCuotasExt: 198.36,
        precioCuotasExtDescuento: 158.69,
        cuotas: 6,
        descuentoUnPago: 30,
        descuentoSuscripcion: 20,
        linkCuotasArg: "https://mpago.la/26SGh3N",
        linkpagoExt: "https://www.paypal.com/ncp/payment/CYUMS9JQQTXEC",
        linkCuotasExt: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-6S211758TT822360ENLJGRQY",
        inscripcionAnio: 2027,
        cuposLlenos: false,
    },
    {
        id: 142,
        codigoT: "400.33",
        nombre: "Diplomatura en Microtrasplante Capilar",
        foto: capilar,
        url: "diplomatura-microtrasplante-capilar",
        tipo: "Diplomatura",
        categoria: ["dermatologia"],
        area: "Trasplante Capilar",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "El Diplomado en Microtrasplante Capilar combina clases virtuales intensivas con práctica hands-on full sobre pacientes reales, en grupos limitados que garantizan una capacitación personalizada. El programa abarca desde las ciencias básicas y la tricología clínica hasta la planificación quirúrgica, las técnicas de extracción e implantación y el manejo postoperatorio.",
        descripcionExtra: [
            "El abordaje es teórico-práctico: el cursante domina la técnica más avanzada y utilizada en la actualidad (F.U.E.) con un enfoque funcional y estético, capacitándose en el manejo integral de la alopecia desde el diagnóstico clínico y los tratamientos médicos no invasivos hasta la intervención quirúrgica."
        ],
        descripcionPreview: "Dominá la técnica FUE de microtrasplante capilar con enfoque funcional y estético, desde el diagnóstico hasta el tratamiento.",
        sobreTitulo: "Formación integral en trasplante capilar FUE",
        objetivos: [
            "Identificar y clasificar los distintos tipos de alopecia mediante herramientas diagnósticas y estudios complementarios.",
            "Prescribir tratamientos médicos no invasivos (farmacoterapia y bioestimulación) basados en la evidencia científica actual.",
            "Diseñar líneas frontales y áreas de cobertura con criterio estético, respetando la anatomía y las diferencias de género.",
            "Ejecutar la extracción, manipulación y colocación de unidades foliculares bajo altos estándares de seguridad, garantizando resultados naturales y de alta densidad."
        ],
        sistemaEvaluacion: ["Práctica final hands-on sobre pacientes reales"],
        destinatarioTags: ["Médicos generales", "Médicos estéticos", "Dermatólogos", "Otras especialidades médicas"],
        director: ["Dr. Alfredo Ruiz Díaz"],
        directorDetalle: ["Director de la Diplomatura · Director de Medicina Estética y Regenerativa FISP · Cirugía Plástica, Estética y Reconstructiva · Docente Internacional en Trasplante y Recuperación Capilar"],
        direccionAcademica: [
            {
                nombre: "Dr. Alfredo Ruiz Díaz",
                detalle: "Director de la Diplomatura · Director de Medicina Estética y Regenerativa FISP · Cirugía Plástica, Estética y Reconstructiva · Docente Internacional en Trasplante y Recuperación Capilar",
            }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Diego Slipak" }
        ],
        directorImg: [diaz],
        inicio: "09/11/2026",
        fin: "14/11/2026",
        "practica final": "13/11/2026 y 14/11/2026",
        diasHorarios: "Cronograma intensivo",
        quincenal: false,
        clases: 8,
        horas: null,
        duracion: null,
        unidades: 8,
        destinatarios: "Dirigido a Médicos, profesionales de la salud y profesionales de otras carreras con título de grado. Obtendrán titulación FISP + Facultad de Medicina UBA.",
        requisitos: [null],
        modalidad: "Virtual + práctica presencial",
        temario: 33,
        precioArg: 3100000,
        precioArgDescuento: 2480000,
        precioCuotasArg: 1100000,
        precioCuotasArgDescuento: 1100000,
        precioExt: 0,
        precioExtDescuento: 0,
        precioCuotasExt: 0,
        precioCuotasExtDescuento: 0,
        cuotas: 3,
        descuentoUnPago: 20,
        descuentoSuscripcion: 0,
        linkCuotasArg: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=e05d491c540a41daa2124c8560696142",
        linkpagoExt: null,
        linkCuotasExt: null,
        inscripcionAnio: 2026,
             pageContent: {
            heroBadge: "Solo 5 vacantes · 2026",
            dataCardTitle: "Datos del programa",
            heroFacts: [
                ["🎓", "Titulación", "FISP + Fac. Medicina UBA"],
                ["💻", "Modalidad", "Virtual + Práctica presencial"],
                ["📚", "Módulos", "8 módulos"],
                ["🤝", "Práctica", "Hands-on con pacientes reales"],
                ["🔒", "Vacantes", "Solo 5 cupos"],
            ],
            infoBarItems: [
                "🩺 Dirigida por el Dr. Alfredo Ruiz Díaz",
                "🎓 Doble titulación FISP + Facultad de Medicina UBA",
                "🔒 Cupos limitados: solo 5 vacantes",
            ],
            aboutTag: "Sobre la diplomatura",
            aboutTitle: "Formación integral en trasplante capilar FUE",
            objectivesTag: "Objetivos del programa",
            audienceTag: "¿A quién está dirigido?",
            temarioHeading: "8 módulos · Teórico-Práctico",
            methodCards: [
                {
                    icon: "📹",
                    title: "Clases virtuales intensivas",
                    text: "Contenido teórico online con docentes especializados en trasplante capilar.",
                },
                {
                    icon: "🤝",
                    title: "Práctica hands-on full",
                    text: "Práctica presencial sobre pacientes reales los días 13 y 14 de noviembre.",
                },
                {
                    icon: "🔒",
                    title: "Grupos limitados",
                    text: "Solo 5 vacantes para garantizar una capacitación personalizada.",
                },
            ],
            showAudienceTags: true,
            sidebarFactsTitle: "Ficha del programa",
            sidebarFacts: [
                ["Programa", "Diplomatura"],
                ["Área", "Trasplante Capilar"],
                ["Módulos", "8"],
                ["Modalidad", "Virtual + Presencial"],
                ["Inicio cursada", "9/11/2026"],
                ["Prácticas presenciales", "13 y 14/11/2026"],
                ["Vacantes", "Solo 5"],
            ],
            sidebarNote: "Cupos muy limitados. Capacitación personalizada.",
            certificationTitle: "Doble titulación",
            certificationDescription:
                "Certificado de Diplomatura emitido por FISP y la Facultad de Medicina de la Universidad de Buenos Aires.",
        },
        cuposLlenos: false,
    },
    {
        id: 344,
        codigoT: "400.32",
        nombre: "Curso de Acompañante Terapéutico Especializado en Adicciones",
        foto: acompAdicciones,
        url: "curso-acomp-terapeutico-adicciones",
        tipo: "Curso",
        categoria: ["salud-mental-y-adicciones", "psiquiatria"],
        area: "Adicciones",
        titulacion: "Título FISP",
        certificaciones: [
            { certificacion: "FISP", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "El consumo problemático de sustancias es una problemática en aumento a nivel mundial que impacta en la salud física y mental de los pacientes, y afecta profundamente la autoestima, la identidad y el sentido de vida. La recuperación no solo implica la desintoxicación, sino también la reconstrucción emocional y espiritual del paciente.",
        descripcionExtra: ["Este curso fortalece el rol del Acompañante Terapéutico en la intervención con pacientes con consumo problemático, priorizando la construcción del vínculo terapéutico, el manejo de crisis y la reinserción social. Con un enfoque interdisciplinario, permite que los AT trabajen en conjunto con equipos de salud mental y adicciones."],
        descripcionPreview: "Formación interdisciplinaria para abordar consumos problemáticos mediante intervención en crisis, vínculo terapéutico y reducción de daños.",
        sobreTitulo: "El rol del AT en el abordaje integral del consumo problemático",
        objetivos: ["Formar en la identificación y abordaje del consumo problemático de sustancias desde una perspectiva interdisciplinaria.", "Desarrollar estrategias de intervención y contención en la atención de personas con consumo problemático.", "Introducir conceptos básicos de toxicología y farmacología adaptados al rol del Acompañante Terapéutico.", "Promover herramientas motivacionales, psicoeducativas y el autocuidado para prevenir el desgaste profesional."],
        sistemaEvaluacion: ["Actividades del campus", "Bibliografía", "Examen final"],
        destinatarioTags: ["Acompañantes Terapéuticos", "Público general", "Familiares y cuidadores", "Trabajadores comunitarios", "Profesionales de salud mental"],
        director: ["Dr. Francisco Dadic"],
        directorDetalle: ["Director académico del curso"],
        direccionAcademica: [
            { nombre: "Dr. Francisco Dadic", detalle: "Director académico del curso" }
        ],
        codireccion: ["Lic. Esp. Leonardo De Vincentiis"],
        codireccionDetalle: ["(MN 72146) · Licenciado en Enfermería"],
        codireccionAcademica: [
            { nombre: "Lic. Esp. Leonardo De Vincentiis", detalle: "(MN 72146) · Licenciado en Enfermería" }
        ],
        equipoDocente: [
            { titulo: "Lic. Esp.", nombre: "Alexis Ramallo" },
            { titulo: "Mag.", nombre: "Cynthia De Armas" }
        ],
        directorImg: [dadic],
        codireccionImg: [devicentiis],
        inicio: null,
        fin: null,
        diasHorarios: null,
        quincenal: false,
        clases: 8,
        horas: null,
        duracion: null,
        unidades: 4,
        destinatarios: "Dirigido al público general. No se requiere título universitario previo. Ideal para acompañantes terapéuticos, familiares, cuidadores y cualquier persona interesada en el abordaje del consumo problemático desde un rol de acompañamiento y contención.",
        requisitos: [null],
        modalidad: "Virtual asincrónico",
        temario: null,
        precioArg: 138240,
        precioArgDescuento: 110592,
        precioCuotasArg: 46080,
        precioCuotasArgDescuento: 46080,
        precioExt: 0,
        precioExtDescuento: 0,
        precioCuotasExt: 0,
        precioCuotasExtDescuento: 0,
        cuotas: 3,
        descuentoUnPago: 20,
        descuentoSuscripcion: 0,
        linkCuotasArg: "https://mpago.la/2w65jH5",
        linkpagoExt: null,
        linkCuotasExt: null,
        cuposLlenos: false,
    },
    {
        id: 309,
        codigoT: "400.28",
        nombre: "Curso Especialista en Skincare",
        foto: skincare,
        url: "diplomatura-skincare",
        tipo: "Curso",
        categoria: ["dermatologia"],
        area: "Skincare · Dermatología",
        titulacion: "Título FISP",
        certificaciones: [
            { certificacion: "FISP", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Este curso brinda los conocimientos teóricos necesarios para comprender los fundamentos científicos del cuidado de la piel y desarrollar habilidades específicas en el diseño y aplicación de rutinas de cuidado facial y corporal.",
        descripcionExtra: ["Los participantes aprenderán a evaluar las necesidades individuales de la piel, recomendar productos y tratamientos adecuados, y desarrollar planes personalizados para diversos tipos de piel y condiciones específicas. Incluye cosmética natural, prevención y tratamiento de problemas cutáneos comunes y las últimas tendencias en el campo del skincare."],
        descripcionPreview: "Fundamentos científicos del cuidado de la piel, rutinas personalizadas, ingredientes clave, tratamientos avanzados y skincare ético.",
        sobreTitulo: "El skincare como ciencia y práctica personalizada",
        objetivos: ["Comprender los fundamentos científicos del cuidado de la piel: anatomía, fisiología y tipos cutáneos.", "Diseñar rutinas de skincare personalizadas según tipo de piel, condición y necesidades individuales del paciente.", "Conocer los ingredientes clave, sus funciones y su correcta combinación para resultados óptimos.", "Incorporar una visión ética y sostenible del skincare, integrando cosmética natural y prácticas responsables."],
        sistemaEvaluacion: ["Actividades en foro", "Examen final"],
        destinatarioTags: ["Cosmetólogas", "Cosmiatras", "Esteticistas", "Interesados en tratamientos faciales", "Interesados en tratamientos corporales"],
        director: ["Dra. Aldana Lallo"],
        directorDetalle: ["Directora · (MP 120.184) · Esp. en Dermatología"],
        direccionAcademica: [
            { nombre: "Dra. Aldana Lallo", detalle: "Directora · (MP 120.184) · Esp. en Dermatología" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [],
        directorImg: [lallo],
        inicio: null,
        fin: null,
        diasHorarios: null,
        quincenal: false,
        clases: null,
        horas: 170,
        duracion: null,
        unidades: 9,
        destinatarios: "Dirigido a cosmetólogas, cosmiatras, esteticistas y todas aquellas personas que busquen especializarse en tratamientos faciales y corporales. No se requiere título universitario previo.",
        requisitos: [
            "Título Secundario"
        ],
        modalidad: "Virtual asincrónico",
        temario: 28,
        precioArg: 437760,
        precioArgDescuento: 350208,
        precioCuotasArg: 145920,
        precioCuotasArgDescuento: 145920,
        precioExt: 0,
        precioExtDescuento: 0,
        precioCuotasExt: 0,
        precioCuotasExtDescuento: 0,
        cuotas: 3,
        descuentoUnPago: 20,
        descuentoSuscripcion: 0,
        linkCuotasArg: "https://mpago.la/2N7Fc75",
        linkpagoExt: null,
        linkCuotasExt: null,
        cuposLlenos: false,
    },
    {
        id: 112,
        codigoT: "400.5",
        nombre: "Curso Superior en Plant Based",
        foto: plantbased,
        url: "diplomatura-nutricion-plant-based",
        tipo: "Curso",
        categoria: ["nutricion"],
        area: "Nutrición Plant Based",
        titulacion: "Título FISP",
        certificaciones: [
            { certificacion: "FISP", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Las plantas son ricas fuentes de nutrientes que nuestro cuerpo necesita y pueden ayudar a prevenir enfermedades crónicas. La nutrición tiene un papel fundamental en el estado de la salud, sobre todo cuando el paciente padece algún tipo de patología.",
        descripcionExtra: ["Este curso brinda a cada profesional todo el conocimiento actualizado y necesario sobre la alimentación basada en plantas (ABP), permitiendo abordar cada paciente de una forma integral y personalizada, fomentando el desarrollo de un correcto ambiente intestinal y metabolismo."],
        descripcionPreview: "Alimentación basada en plantas: nutrientes críticos, microbiota, enfermedades crónicas y abordaje nutricional durante el ciclo vital.",
        sobreTitulo: "Alimentación basada en plantas: ciencia, práctica y prevención",
        objetivos: ["Brindar los conocimientos científicos actualizados sobre la alimentación basada en plantas y su impacto en la salud.", "Establecer programas de tratamiento que incluyan a todo el equipo de salud, con educación terapéutica y estrategias de adherencia.", "Identificar nutrientes críticos en la ABP, signos de carencias, factores inhibidores y facilitadores, y uso de suplementos.", "Aportar herramientas para favorecer los cambios necesarios en el estilo de vida del paciente para lograr un óptimo resultado."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Médicos", "Licenciadas/os en Nutrición", "Estudiantes último año (Medicina o Nutrición)", "Graduados UBA", "Otras universidades argentinas", "Universidades extranjeras"],
        director: ["Lic. Laura Iermoli"],
        directorDetalle: ["Directora · (MN 9335) · Lic. en Nutrición"],
        direccionAcademica: [
            { nombre: "Lic. Laura Iermoli", detalle: "Directora · (MN 9335) · Lic. en Nutrición" }
        ],
        codireccion: ["Dra. Elena Pastor Manfredi"],
        codireccionDetalle: ["Co-Directora de la Diplomatura"],
        codireccionAcademica: [
            { nombre: "Dra. Elena Pastor Manfredi", detalle: "Co-Directora de la Diplomatura" }
        ],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Raúl F. Pastor" },
            { titulo: "Dr.", nombre: "Roberto H. Iermoli" }
        ],
        directorImg: [iermoli],
        codireccionImg: [manfredi],
        inicio: null,
        fin: null,
        diasHorarios: null,
        quincenal: false,
        clases: null,
        horas: 170,
        duracion: null,
        unidades: 7,
        destinatarios: "Dirigido a médicos, licenciados/as en nutrición y estudiantes del último año de Medicina o Nutrición. Graduados de la UBA, otras universidades argentinas o universidades extranjeras.",
        requisitos: [
            "a) Ser graduado de la Universidad de Buenos Aires con título de grado correspondiente a la carrera de Medicina o Nutrición.",
            "b) Ser graduado de otras universidades argentinas con título de grado correspondiente a la carrera de Medicina o Nutrición.",
            "c) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Medicina o Nutrición.",
            "d) Ser estudiante regular del último año de la carrera de Medicina o Nutrición."
        ],
        modalidad: "Virtual asincrónico",
        temario: 5,
        precioArg: 403200,
        precioArgDescuento: 322560,
        precioCuotasArg: 134400,
        precioCuotasArgDescuento: 134400,
        precioExt: 0,
        precioExtDescuento: 0,
        precioCuotasExt: 0,
        precioCuotasExtDescuento: 0,
        cuotas: 3,
        descuentoUnPago: 20,
        descuentoSuscripcion: 0,
        linkCuotasArg: "https://mpago.la/2qccbMb",
        linkpagoExt: null,
        linkCuotasExt: null,
        cuposLlenos: false,
    },
    {
        id: 341,
        codigoT: "400.29",
        nombre: "Curso de Operador Prehospitalario de Emergencias",
        foto: prehospitalario,
        url: "curso-operador-prehospitalario-emergencias",
        tipo: "Curso",
        categoria: ["emergencias"],
        area: "Emergencias",
        titulacion: "Título FISP",
        certificaciones: [
            { certificacion: "FISP", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Este curso proporciona una formación profesional integral, profundizando el conocimiento semiológico y la toma de decisiones en el campo de la atención prehospitalaria. Los participantes aprenderán a conocer la legislación vigente, evaluar ordenadamente la semiología del paciente y estimular el pensamiento crítico ante situaciones de emergencia.",
        descripcionExtra: ["Con 25 unidades que abarcan desde principios generales hasta eventos con víctimas múltiples, el programa forma operadores capaces de responder eficazmente ante cualquier emergencia médica, trauma o situación crítica en el ámbito prehospitalario."],
        descripcionPreview: "Formación profesional en atención prehospitalaria: semiología, toma de decisiones, emergencias médicas, trauma y pediatría.",
        sobreTitulo: "Formación especializada en emergencias prehospitalarias",
        objetivos: ["Proporcionar formación profesional, profundizando el conocimiento semiológico y la toma de decisiones en atención prehospitalaria.", "Conocer la legislación vigente aplicable a las emergencias prehospitalarias y los aspectos médico-legales y éticos del rol.", "Evaluar ordenadamente la semiología del paciente mediante evaluación primaria y secundaria sistemática.", "Estimular el pensamiento crítico y la toma de decisiones ante situaciones de emergencia complejas y eventos con víctimas múltiples."],
        sistemaEvaluacion: ["Teórico", "Examen Parcial", "Examen Final"],
        destinatarioTags: ["Personal Bombero", "Defensa Civil", "Rescatadores", "Enfermeros", "Interesados en emergencias"],
        director: ["Dr. Luis Jorge Montessi", "Dr. Alejandro Nicolau"],
        directorDetalle: ["(M.N. 62268) · Médico Emergentólogo · SAME CABA", "(MN. 158146) · Médico Emergentólogo · SAME CABA"],
        direccionAcademica: [
            { nombre: "Dr. Luis Jorge Montessi", detalle: "(M.N. 62268) · Médico Emergentólogo · SAME CABA" },
            { nombre: "Dr. Alejandro Nicolau", detalle: "(MN. 158146) · Médico Emergentólogo · SAME CABA" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [],
        directorImg: [montessi, nicolau],
        inicio: null,
        fin: null,
        diasHorarios: null,
        quincenal: false,
        clases: null,
        horas: 170,
        duracion: null,
        unidades: 25,
        destinatarios: "Dirigido a personas relacionadas con la atención de emergencias prehospitalarias y a toda aquella persona interesada en el mundo de las emergencias.",
        requisitos: [
            "Título secundario"
        ],
        modalidad: "Virtual asincrónico",
        temario: 29,
        precioArg: 299520,
        precioArgDescuento: 239616,
        precioCuotasArg: 99840,
        precioCuotasArgDescuento: 99840,
        precioExt: 0,
        precioExtDescuento: 0,
        precioCuotasExt: 0,
        precioCuotasExtDescuento: 0,
        cuotas: 3,
        descuentoUnPago: 20,
        descuentoSuscripcion: 0,
        linkCuotasArg: "https://mpago.la/1uhoioy",
        linkpagoExt: null,
        linkCuotasExt: null,
        cuposLlenos: false,
    },
    {
        id: 342,
        codigoT: "400.30",
        nombre: "Programa Ampliado de Inmunizaciones",
        foto: inmunizaciones,
        url: "programa-inmunizaciones",
        tipo: "Curso",
        categoria: ["enfermeria"],
        area: "Enfermería · Vacunación",
        titulacion: "Título FISP",
        certificaciones: [
            { certificacion: "FISP", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "El Programa Ampliado de Inmunizaciones (PAI) es una de las estrategias de salud pública con mayor impacto en la reducción de enfermedades prevenibles. Este curso brinda la información y capacitación necesarias para adquirir competencia en el manejo de vacunas, las técnicas de aplicación y el conocimiento actualizado de los esquemas vigentes.",
        descripcionExtra: ["Una capacitación clave para enfermeros y farmacéuticos que buscan profundizar en el área de mayor salida laboral y mejor remuneración dentro del campo de la enfermería."],
        descripcionPreview: "Capacitación en manejo de vacunas: técnicas de administración, esquemas vigentes, enfermedades del programa y cadena de frío.",
        sobreTitulo: "Competencia profesional en el manejo de vacunas",
        objetivos: ["Proporcionar información y capacitación para adquirir competencia en el manejo de vacunas del programa nacional.", "Adquirir conocimientos sobre la inmunización por vacunas y las técnicas de aplicación en sus diferentes vías.", "Conocer los principios de conservación, cadena de frío y gestión de vacunas en organizaciones de salud.", "Capacitarse en el área de enfermería con mayor salida laboral y mejor remuneración del sector."],
        sistemaEvaluacion: ["Teórico", "Examen Parcial", "Examen Final"],
        destinatarioTags: ["Enfermeros/as", "Licenciados/as en Enfermería", "Farmacéuticos", "Estudiantes 3er año Enfermería"],
        director: ["Dr. Abel Luis Agüero"],
        directorDetalle: ["Director del Instituto de Historia de la Medicina · Facultad de Medicina · Magíster en Salud Pública"],
        direccionAcademica: [
            { nombre: "Dr. Abel Luis Agüero", detalle: "Director del Instituto de Historia de la Medicina · Facultad de Medicina · Magíster en Salud Pública" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [],
        directorImg: [aguero],
        inicio: null,
        fin: null,
        diasHorarios: null,
        quincenal: false,
        clases: null,
        horas: 170,
        duracion: null,
        unidades: 6,
        destinatarios: "Dirigido a enfermeros/as, Licenciados/as en Enfermería, farmacéuticos y estudiantes del 3er año de Enfermería que buscan especializarse en vacunación e inmunización.",
        requisitos: [
            "Poseer título de Lic. en Enfermería, Farmacéutico o ser estudiante del tercer año de Enfermería."
        ],
        modalidad: "Virtual asincrónico",
        temario: 30,
        precioArg: 110592,
        precioArgDescuento: 88474,
        precioCuotasArg: 36864,
        precioCuotasArgDescuento: 36864,
        precioExt: 0,
        precioExtDescuento: 0,
        precioCuotasExt: 0,
        precioCuotasExtDescuento: 0,
        cuotas: 3,
        descuentoUnPago: 20,
        descuentoSuscripcion: 0,
        linkCuotasArg: "https://mpago.la/183hRX2",
        linkpagoExt: null,
        linkCuotasExt: null,
        cuposLlenos: false,
    },
    {
        id: 343,
        codigoT: "400.31",
        nombre: "Curso de RCP + DEA",
        foto: rcp,
        url: "curso-rcp",
        tipo: "Curso",
        categoria: ["emergencias"],
        area: "Emergencias · RCP",
        titulacion: "Título FISP",
        certificaciones: [
            { certificacion: "FISP", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Saber cómo actuar ante un paro cardiorrespiratorio puede marcar la diferencia entre la vida y la muerte. Este curso brinda los conocimientos y técnicas necesarios para responder con eficacia ante una emergencia cardiovascular, incluyendo el uso correcto del Desfibrilador Externo Automático (DEA) en ambientes cardioprotegidos.",
        descripcionExtra: ["Con un enfoque práctico y accesible, está pensado tanto para profesionales de la salud y servicios de emergencia como para cualquier persona que quiera estar preparada para actuar en situaciones de riesgo de vida."],
        descripcionPreview: "Aprendé técnicas de RCP y el uso del DEA para reconocer una emergencia, manejar la escena y actuar ante situaciones de riesgo de vida.",
        sobreTitulo: "RCP y DEA: herramientas para salvar vidas",
        objetivos: ["Brindar conocimientos y técnicas necesarias para responder ante un paro cardiorrespiratorio.", "Capacitar en el uso correcto del Desfibrilador Externo Automático (DEA) en ambientes cardioprotegidos.", "Preparar a profesionales y público general para actuar con eficacia en situaciones de riesgo de vida."],
        sistemaEvaluacion: ["Examen Final"],
        destinatarioTags: ["Operadores Prehospitalarios", "Personal de Salud", "Bomberos", "Policías", "Rescatistas", "Guardavidas", "Entrenadores", "Público general"],
        director: ["Dr. Luis Jorge Montessi", "Dr. Alejandro Nicolau"],
        directorDetalle: ["(M.N. 62268) · Médico Emergentólogo", "Cuerpo Docente"],
        direccionAcademica: [
            { nombre: "Dr. Luis Jorge Montessi", detalle: "(M.N. 62268) · Médico Emergentólogo" },
            { nombre: "Dr. Alejandro Nicolau", detalle: "Cuerpo Docente" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [],
        directorImg: [montessi, nicolau],
        inicio: null,
        fin: null,
        diasHorarios: null,
        quincenal: false,
        clases: null,
        horas: null,
        duracion: null,
        unidades: 4,
        destinatarios: "Dirigido a todo aquel que quiera estar preparado para actuar ante una emergencia cardiovascular. No se requiere experiencia previa ni título profesional.",
        requisitos: [null],
        modalidad: "Virtual asincrónico",
        temario: 31,
        precioArg: 43200,
        precioArgDescuento: 43200,
        precioCuotasArg: 14400,
        precioCuotasArgDescuento: 14400,
        precioExt: 0,
        precioExtDescuento: 0,
        precioCuotasExt: 0,
        precioCuotasExtDescuento: 0,
        cuotas: 3,
        descuentoUnPago: 0,
        descuentoSuscripcion: 0,
        linkCuotasArg: "https://mpago.la/11cJGRv",
        linkpagoExt: null,
        linkCuotasExt: null,
        cuposLlenos: false,
    }
];

const courseThemePresets = {
    nutricion: {
        primary: "#1f6a51",
        primaryDark: "#0e4d38",
        primaryLight: "#8bbcae",
        pale: "#dfeee8",
        background: "#f7fbf8",
        navy: "#164638",
        navyDark: "#091f18",
        heroStart: "#091f18",
        heroMid: "#1f6a51",
        heroEnd: "#164638",
    },
    toxicoAdicciones: {
        primary: "#9c221d",
        primaryDark: "#620604",
        primaryLight: "#d88b86",
        pale: "#f7e1df",
        background: "#fff8f7",
        navy: "#5d1715",
        navyDark: "#220505",
        heroStart: "#220505",
        heroMid: "#9c221d",
        heroEnd: "#5d1715",
    },
    neurocardio: {
        primary: "#7a5a40",
        primaryDark: "#261c12",
        primaryLight: "#cdb195",
        pale: "#f2e7dc",
        background: "#fcf8f4",
        navy: "#574230",
        navyDark: "#1e140d",
        heroStart: "#1e140d",
        heroMid: "#7a5a40",
        heroEnd: "#574230",
    },
    enfermeria: {
        primary: "#5a82ad",
        primaryDark: "#375d85",
        primaryLight: "#aac0d8",
        pale: "#e4edf5",
        background: "#f8fbff",
        navy: "#294a6e",
        navyDark: "#101d2c",
        heroStart: "#101d2c",
        heroMid: "#5a82ad",
        heroEnd: "#294a6e",
    },
    gineco: {
        primary: "#8f4a63",
        primaryDark: "#5b2638",
        primaryLight: "#d5a3b5",
        pale: "#f7e5ec",
        background: "#fef9fb",
        navy: "#6a3247",
        navyDark: "#261019",
        heroStart: "#261019",
        heroMid: "#8f4a63",
        heroEnd: "#6a3247",
    },
    marketing: {
        primary: "#892c4f",
        primaryDark: "#4c081e",
        primaryLight: "#d394aa",
        pale: "#f7e3ea",
        background: "#fff9fb",
        navy: "#642138",
        navyDark: "#24040d",
        heroStart: "#24040d",
        heroMid: "#892c4f",
        heroEnd: "#642138",
    },
    criminalistica: {
        primary: "#4c5564",
        primaryDark: "#1c1f26",
        primaryLight: "#a6afbd",
        pale: "#e6eaef",
        background: "#fafbfd",
        navy: "#323844",
        navyDark: "#0f1115",
        heroStart: "#0f1115",
        heroMid: "#4c5564",
        heroEnd: "#323844",
    },
    tecnologia: {
        primary: "#31507a",
        primaryDark: "#131b2d",
        primaryLight: "#9aadd0",
        pale: "#e1e8f3",
        background: "#f7f9fc",
        navy: "#253752",
        navyDark: "#0b1120",
        heroStart: "#0b1120",
        heroMid: "#31507a",
        heroEnd: "#253752",
    },
    medicinaLaboral: {
        primary: "#1d6460",
        primaryDark: "#053635",
        primaryLight: "#93bbb8",
        pale: "#dff0ef",
        background: "#f7fbfb",
        navy: "#0f4947",
        navyDark: "#031c1b",
        heroStart: "#031c1b",
        heroMid: "#1d6460",
        heroEnd: "#0f4947",
    },
    dermatologia: {
        primary: "#4264b7",
        primaryDark: "#192e6b",
        primaryLight: "#a3b6ea",
        pale: "#e5ebfb",
        background: "#f7f9ff",
        navy: "#243d82",
        navyDark: "#0c1636",
        heroStart: "#0c1636",
        heroMid: "#4264b7",
        heroEnd: "#243d82",
    },
    rcpUrgencias: {
        primary: "#c34036",
        primaryDark: "#931717",
        primaryLight: "#ef9b94",
        pale: "#fbe3e1",
        background: "#fff8f7",
        navy: "#7a211e",
        navyDark: "#2c0707",
        heroStart: "#2c0707",
        heroMid: "#c34036",
        heroEnd: "#7a211e",
    },
    skincare: {
        primary: "#af8d57",
        primaryDark: "#856735",
        primaryLight: "#dcc8a5",
        pale: "#f5ede2",
        background: "#fdfaf7",
        navy: "#6b542d",
        navyDark: "#2c2111",
        heroStart: "#2c2111",
        heroMid: "#af8d57",
        heroEnd: "#6b542d",
    },
    paiAcompanante: {
        primary: "#2484b8",
        primaryDark: "#065b88",
        primaryLight: "#8dcee9",
        pale: "#e1f2f9",
        background: "#f7fcfe",
        navy: "#0a4e72",
        navyDark: "#041e2c",
        heroStart: "#041e2c",
        heroMid: "#2484b8",
        heroEnd: "#0a4e72",
    },
    investigacionClinica: {
        primary: "#2AA69B",
        primaryDark: "#146C66",
        primaryLight: "#91D8D1",
        pale: "#DDF4F1",
        background: "#F6FCFB",
        navy: "#145D59",
        navyDark: "#082C2B",
        heroStart: "#082C2B",
        heroMid: "#218F86",
        heroEnd: "#145D59",
    },
    slate: {
        primary: "#4c5564",
        primaryDark: "#1c1f26",
        primaryLight: "#a6afbd",
        pale: "#e6eaef",
        background: "#fafbfd",
        navy: "#323844",
        navyDark: "#0f1115",
        heroStart: "#0f1115",
        heroMid: "#4c5564",
        heroEnd: "#323844",
    },
};

const courseRouteOverrides = {
    "curso-acomp-terapeutico-adicciones": {
        routeFamily: "cursos",
        routeSlug: "acompanante-terapeutico-adicciones",
        routeAliases: [
            {
                family: "cursos",
                slug: "acomp-terapeutico-adicciones",
            }
        ],
    },
    "diplomatura-skincare": {
        routeFamily: "cursos",
        routeSlug: "especialista-skincare",
        routeAliases: [
            {
                family: "cursos",
                slug: "skincare",
            }
        ],
    },
    "diplomatura-nutricion-plant-based": {
        routeFamily: "cursos",
        routeSlug: "nutricion-plant-based",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "nutricion-plant-based",
            }
        ],
    },
    "programa-inmunizaciones": {
        routeFamily: "cursos",
        routeSlug: "programa-ampliado-inmunizaciones",
        routeAliases: [
            {
                family: "cursos",
                slug: "programa-inmunizaciones",
            }
        ],
    },
    "curso-rcp": {
        routeFamily: "cursos",
        routeSlug: "reanimacion-cardiopulmonar",
        routeAliases: [
            {
                family: "cursos",
                slug: "rcp",
            }
        ],
    },
    "diplomatura-gestion-telemedicina": {
        routeFamily: "diplomaturas",
        routeSlug: "gestion-sistemas-telemedicina",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "gestion-telemedicina",
            }
        ],
    },
    "posgrado-enfermeria-oncologica": {
        routeFamily: "posgrados",
        routeSlug: "enfermeria-oncologica",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "enfermeria-oncologica",
            },
            {
                family: "posgrados",
                slug: "diplomatura-enfermeria-oncologica",
            },
            {
                family: "diplomaturas",
                slug: "diplomatura-enfermeria-oncologica",
            }
        ],
    },
    "diplomatura-nutricion-deportiva": {
        routeFamily: "diplomaturas",
        routeSlug: "nutricion-deportiva-alto-rendimiento",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "nutricion-deportiva",
            }
        ],
    },
    "diplomatura-nutricion-diabetes": {
        routeFamily: "diplomaturas",
        routeSlug: "nutricion-diabetes-tipo2",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "nutricion-diabetes",
            }
        ],
    },
    "diplomatura-criminalistica-ciencias-forenses": {
        routeFamily: "diplomaturas",
        routeSlug: "criminalistica-ciencias-forenses",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "criminalistica-forenses",
            }
        ],
    },
    "diplomatura-ginecologia-regenerativa-estetica-funcional": {
        routeFamily: "diplomaturas",
        routeSlug: "ginecologia-regenerativa-estetica-funcional",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "ginecologia-regenerativa",
            }
        ],
    },
};

const courseThemeOverrides = {
    "curso-acomp-terapeutico-adicciones": "paiAcompanante",
    "diplomatura-skincare": "skincare",
    "diplomatura-nutricion-plant-based": "nutricion",
    "curso-operador-prehospitalario-emergencias": "rcpUrgencias",
    "programa-inmunizaciones": "paiAcompanante",
    "curso-rcp": "rcpUrgencias",
    "diplomatura-medicina-adicciones": "toxicoAdicciones",
    "diplomatura-nutricion-deportiva": "nutricion",
    "diplomatura-nutricion-diabetes": "nutricion",
    "diplomatura-nutricion-microbiota": "nutricion",
    "diplomatura-urgencias-neurocardiologicas": "neurocardio",
    "diplomatura-bioremodelacion-facial": "dermatologia",
    "diplomatura-microtrasplante-capilar": "dermatologia",
    "diplomatura-criminalistica-ciencias-forenses": "criminalistica",
    "diplomatura-ginecologia-regenerativa-estetica-funcional": "gineco",
    "diplomatura-ia-medica": "tecnologia",
    "diplomatura-gestion-telemedicina": "tecnologia",
    "diplomatura-medicina-laboral-energia-mineria": "medicinaLaboral",
    "diplomatura-marketing-medico": "marketing",
    "posgrado-investigacion-clinica": "investigacionClinica",
    "posgrado-bigdata-ia-salud": "tecnologia",
    "posgrado-gestion-de-establecimientos-sistemas-de-salud-digital": "tecnologia",
    "posgrado-psiquiatria-clinica": "toxicoAdicciones",
    "posgrado-dermatologia-estetica-terapeutica": "dermatologia",
    "posgrado-nutricion-clinica": "nutricion",
    "posgrado-nutricion-microbiota": "nutricion",
    "posgrado-toxicologia": "toxicoAdicciones",
    "posgrado-gestion-administracion-enfermeria": "enfermeria",
    "diplomatura-enfermeria-neurologica": "enfermeria",
    "posgrado-enfermeria-oncologica": "enfermeria",
    "diplomatura-enfermeria-consumos-problematicos": "enfermeria",
};

const defaultRouteFamilyByType = {
    Curso: "cursos",
    Diplomatura: "diplomaturas",
    Posgrado: "posgrados",
};

const stripRoutePrefix = (value) =>
    value
        .replace(/^(posgrado|diplomatura|curso)-/, "")
        .replace(/^programa-/, "programa-");

const resolveCourseTheme = (curso) => {
    const themeKey = courseThemeOverrides[curso.url] || "slate";
    const theme = courseThemePresets[themeKey] || courseThemePresets.slate;

    return {
        key: themeKey,
        ...theme,
    };
};

cursos.forEach((curso) => {
    const routeOverride = courseRouteOverrides[curso.url] || {};
    const routeFamily =
        routeOverride.routeFamily || defaultRouteFamilyByType[curso.tipo] || "cursos";
    const routeSlug = routeOverride.routeSlug || stripRoutePrefix(curso.url);
    const routeAliases = [...(routeOverride.routeAliases || [])];

    if (curso.url !== routeSlug) {
        routeAliases.push({ family: routeFamily, slug: curso.url });
    }

    Object.assign(curso, {
        "practica final": curso["practica final"] ?? null,
        permiteCodigoDescuento: curso.permiteCodigoDescuento ?? false,
        routeFamily,
        routeSlug,
        routeAliases,
        theme: resolveCourseTheme(curso),
        hasMediaAssets: Boolean(curso.video || curso.brochure),
    });
});

export { cursos };
